import { Injectable, Injector } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from '../app/popups/message/message.component';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { SummaryComponent } from '../app/popups/summary/summary.component';
import { ViewImageComponent } from '../app/shared/view-image/view-image.component';
import { SelectBusinessComponent } from '../app/popups/select-business/select-business.component';
import { LocalDatePipe } from '../app/pipes/local-date.pipe';
import { environment } from './../environments/environment';
import {
  ExcelDownloadTemplateType,
  FileSaveService,
  FileType,
} from './file-save.service';
import { BusinessForPrinting, ReceiptHtmlPrint, ReceiptPrintData, TitleForPrinting } from 'src/app/supporting/receiptPrint';
import {
  DevicePrinterSetupWrapper,
  PrinterSetup,
} from 'src/app/entities/response';

@Injectable({
  providedIn: 'root',
})
export class LocalService {
  public lastUsedSettings: LastUsedKey[] = null;
  public countryCodes: KeyValues15[];
  public asCtryCode: string = 'ind';
  public currentTimeZones: KeyValues3[] = [];
  directUrl: string[] = ['whitelist-access'];
  public galleryViewUrl: string[] = [];
  offlineServiceTempFolder: string = '';
  directUrlWithoutLogin: string[] = [
    'pricing-calculator',
    'guide',
    'lang/',
    'rv/',
    'rv-print/',
    'bv/',
  ];
  plainDirectUrl: string[] = [];
  directUrlWithLogin: string[] = ['rdir'];
  maxIntegerLength = 2147483647;
  redirectUrlAfterLogin: string = '';
  public navigateToPage: PageKey;
  public redirectUrl = '';
  public isEnableAutoLoginNextTime = false;
  lastUrl: string = '';
  public viewAsCountryCodeUserId: KeyValueSet | undefined | null;
  public viewAsReturnCountryCodeUserId: KeyValueSet | undefined | null;
  public selected: Selected = {
    countryCode: '',
    applicationLanguage: '',
    token: '',
    user: '',
  } as Selected;
  public tokenNumber = '';
  public allowedPageActions: AllowedPageAction[] = [] as AllowedPageAction[];
  isInternetAvailable = navigator.onLine;
  isPrimaryServiceDown = false;
  public languages: KeyValues3[];
  public languagesEquivalent: KeyValues3[];
  public isPopupBlurEnabled: number = 0;
  public selectedLanguageCode: any = 'en';
  public currentPageKey: PageKey = PageKey.None;
  public pricing: Pricing[];
  public selectedMenu: KeyValues10 = null;
  collapsedMenu: string[] = [];
  hiddenMenu: string[] = [];
  public languageContent: any = null;
  public basicParams: LoginAsParam;
  public basicParamsString: string = '';
  public loggedMember: LoggedMemberWrapper;
  public publicMenus: Menus[] = [];
  public businessRoleForUsers: BusinessRoleForUser[] =
    [] as BusinessRoleForUser[];
  public minDate: string = '05-05-2021';
  public barCodePrefix: string = 'rdir/brc';
  public barcodeSplitChar = '-';
  public localBarCodePrefix: string = 'lb';
  public localBarCodeSufffix: string = 'lb';
  public lastPageSetup: LastPagingSetup[] = [];
  public qrCodeRedirected: DecodedQrCode = null;
  public isHideDummy = true;
  referencePrefix: string = 'rdir/ref-';
  public pageKeyBeforeRedirectToSeller: PageKey = PageKey.None;
  public isAddServiveProvider = false;
  public selectedPageName: KeyValueSet;
  public dropDownConfig: any = {
    displayKey: 'value',
    search: true,
    height: 'auto',
    placeholder: 'Select',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'value',
  };
  printedLanguages: string[] = [];
  defaultStyles: string;
  receiptPrintDatas: ReceiptPrintData[] = [];
  public billingStatus: KeyValueSet[];
  public deliveryTypes: KeyValueSet[];
  public paymentTypes: KeyValueSet[];
  public qrPaymentStatus: KeyValueSet[];
  public businessTypes: KeyValueSet[];
  public galleryTypes: KeyValueSet[];
  receiptOptions: KeyValueSet[];
  public lookupTypes: KeyValueSet[];
  countryLocationLevels: KeyValueSet[];
  loginWithCountryAndPhoneNumber: string;
  public measurementTypes: KeyValueSet[];
  public usageLimits: KeyValueInt[] = [];
  menusWithoutLogin: string[] = [
    'rdir',
    'pricing-calculator',
    'guide',
    'lang/',
  ];
  public billQty: number = null;
  public sideBarBodyHeight = window.outerHeight - 120;
  public windowWidth = window.innerWidth;
  public windowHeight = window.innerHeight;
  reques = '';
  userDevicePrinterSetupWrapper: DevicePrinterSetupWrapper = {
    devicePrinterSetups: [],
    printerTemplateOffline: [],
  } as DevicePrinterSetupWrapper;
  businesesPrinterSetup: PrinterSetup[] = [];

  public deductionMethods: KeyValueSet[];
  public planPurchaseInvoiceStatuses: KeyValueSet[];

  CustomStyleNames: KeyValueSet[] = [
    { isSelected: false, key: 'isBold', value: '0', s_value: 'boolean' },
    { isSelected: false, key: 'fontSize', value: '0', s_value: 'number' },
    { isSelected: false, key: 'isCenter', value: '0', s_value: 'boolean' },
    { isSelected: false, key: 'isRight', value: '0', s_value: 'boolean' },
    { isSelected: false, key: 'isLeft', value: '0', s_value: 'boolean' },
    { isSelected: false, key: 'isItalic', value: '0', s_value: 'boolean' },
    { isSelected: false, key: 'isUnderline', value: '0', s_value: 'boolean' },
    { isSelected: false, key: 'marginTop', value: '0', s_value: 'number' },
    { isSelected: false, key: 'marginBottom', value: '0', s_value: 'number' },
    { isSelected: false, key: 'marginLeft', value: '0', s_value: 'number' },
    { isSelected: false, key: 'marginRight', value: '0', s_value: 'number' },
    { isSelected: false, key: 'lineHeight', value: '0', s_value: 'number' },
    { isSelected: false, key: 'letterSpacing', value: '0', s_value: 'number' },
    { isSelected: false, key: 'width', value: '0', s_value: 'number' },
    { isSelected: false, key: 'height', value: '0', s_value: 'number' },
  ];

  lastBillDeliveryType: DeliveryType;
  lastBillPaymentMethod: PaymentType;
  isOfflineServiceAvailable?: boolean;

  dataWhileClosingPopupAndTriggerButton: any;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private fileSaveService: FileSaveService,
    private injector: Injector,
  ) { }

  public getQrCodeRedirected(): DecodedQrCode {
    let qrCodeRedirected = this.qrCodeRedirected;
    this.qrCodeRedirected = null;
    return qrCodeRedirected;
  }

  public isDirectUrl(): boolean {
    return (
      this.directUrl.filter((x) => window.location.href.indexOf(x) > -1)
        .length > 0 || this.isPlainDirectUrl()
    );
  }

  public isPlainDirectUrl(): boolean {
    return (
      this.plainDirectUrl.filter((x) => window.location.href.indexOf(x) > -1)
        .length > 0
    );
  }

  getCurrentTimeZoneCountryId(): string {
    let rtn = '';
    if (this.currentTimeZones && this.currentTimeZones.length > 0) {
      rtn = this.currentTimeZones[0].key;
    } else if (this.countryCodes.length > 0) {
      rtn = this.countryCodes[0].key;
    }
    return rtn;
  }

  onTriggerClass(className: string, timeDelay: number = 1000) {
    if (className) {
      setTimeout(() => {
        let elements = document.getElementsByClassName(className);
        for (var i = 0; i < elements.length; i++) {
          let element = elements[i] as HTMLElement;
          element.click();
        }
      }, timeDelay);
    }
  }

  onTriggerId(id: string) {
    if (id) {
      setTimeout(() => {
        let element = document.getElementById(id);
        if (element) {
          element.click();
        }
      }, 1000);
    }
  }

  onGetCurrentDeviceSettingsOfBusiness(): DeviceInfoSetting | undefined {
    return this.loggedMember?.deviceSettings?.find(x => x.BusinessId == this.getSelectedBusinessId());
  }

  public isUserHasBusinessRole(
    businessId: string,
    role: RelationShipRole,
  ): boolean {
    let hasAccess = false;
    if (businessId && this.selected.user) {
      const item = this.businessRoleForUsers.find(
        (x) => x.businessId == businessId && x.userId == this.selected.user,
      );
      hasAccess = item && item.roles.includes(role);
      if (!hasAccess) {
        const loggedRole = this.loggedMember.allowedMenus.find(x => x.businessId == this.getSelectedBusinessId())?.menus
          .find((x) => x.menu.v3 == 'admin_panel_settings')
          ?.subMenus.find(
            (x) => x.menu.v6 && parseInt(x.menu.v6) == PageKey.SellersAdmin,
          );
        if (loggedRole) {
          hasAccess = true;
        }
      }
    }
    return hasAccess;
  }

  public isBusinessOptionEnabled(
    businessId: string,
    businessEnabledOption: BusinessEnabledOption,
  ): boolean {
    if (this.loggedMember && this.loggedMember.businesses) {
      const business = this.loggedMember.businesses.find(
        (x) => x.v5 == 'BU' && x.key == businessId,
      );
      const businessEanbledOptions: BusinessEnabledOption[] = business
        ? (business.v8 as string)
          .split(',')
          .map((x) => parseInt(x))
          .filter((x) => x && x > 0)
        : [];
      return businessEanbledOptions.includes(businessEnabledOption);
    } else {
      return false;
    }
  }

  public getBusinessTokenFormatType(businessId: string): TokenFormatType {
    if (this.loggedMember && this.loggedMember.businesses) {
      const business = this.loggedMember.businesses.find(
        (x) => x.v5 == 'BU' && x.key == businessId,
      );
      if (business && business.v12 && business.v12.length > 0) {
        return parseInt(business.v12);
      } else {
        return TokenFormatType.YearMonthDay;
      }
    } else {
      return TokenFormatType.YearMonthDay;
    }
  }

  public getTokenDateSplitter(businessId: string): string {
    if (this.loggedMember && this.loggedMember.businesses) {
      const business = this.loggedMember.businesses.find(
        (x) => x.v5 == 'BU' && x.key == businessId,
      );
      if (business && business.v14 && business.v14.length > 0) {
        return business.v14;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  public getDefaultPrintingLanguage(businessId: string): string {
    if (this.loggedMember && this.loggedMember.businesses) {
      const business = this.loggedMember.businesses.find(
        (x) => x.v5 == 'BU' && x.key == businessId,
      );
      if (business && business.v13 && business.v13.length > 0) {
        return business.v13;
      } else {
        return this.selected.applicationLanguage;
      }
    } else {
      return this.selected.applicationLanguage;
    }
  }

  public isDirectUrlWithLogin(): boolean {
    return (
      this.directUrlWithLogin.filter(
        (x) => window.location.href.indexOf(x) > -1,
      ).length > 0
    );
  }

  public getContactPrefixByCountryCode(strCtryCode: string = ''): string {
    if (strCtryCode == '') strCtryCode = this.selected.countryCode;
    return strCtryCode && strCtryCode != '' && this.countryCodes
      ? this.countryCodes.find((x) => x.v2 == strCtryCode).v3
      : '0';
  }

  public getContactMaxDigitByCountryCode(strCtryCode: string = ''): number {
    if (strCtryCode == '') strCtryCode = this.selected.countryCode;
    return strCtryCode && strCtryCode != '' && this.countryCodes
      ? parseInt(this.countryCodes.find((x) => x.v2 == strCtryCode).v4)
      : 0;
  }

  public getPostalCodeMaxDigitByCountryCode(strCtryCode: string = ''): number {
    if (strCtryCode == '') strCtryCode = this.selected.countryCode;
    const item = this.countryCodes.find((x) => x.v2 == strCtryCode);
    return strCtryCode && strCtryCode != '' && this.countryCodes && item
      ? parseInt(item.v12)
      : 0;
  }

  public getIsAlphaNumericPostalCodeByCountryCode(
    strCtryCode: string = '',
  ): boolean {
    if (strCtryCode == '') strCtryCode = this.selected.countryCode;
    const item = this.countryCodes.find((x) => x.v2 == strCtryCode);
    return strCtryCode && strCtryCode != '' && this.countryCodes && item
      ? item.v11 == '1'
      : false;
  }

  public getLocationLevelByCountryId(
    id: string,
    locationLevel: string,
  ): string {
    return id && id != '' && this.countryCodes
      ? this.countryCodes.find((x) => x.key == id)[locationLevel]
      : '';
  }

  public getLocationLevelByCountryCode(
    strCtryCode: string,
    locationLevel: string,
  ): string {
    return strCtryCode && strCtryCode != '' && this.countryCodes
      ? this.countryCodes.find((x) => x.v2 == strCtryCode)[locationLevel]
      : '';
  }

  public getCurrencyByCountryCode(strCtryCode: string = ''): string {
    if (strCtryCode == '') strCtryCode = this.getLoginAsCountryCode();
    let item = this.countryCodes
      ? this.countryCodes.find((x) => x.v2 == strCtryCode)
      : null;
    return strCtryCode && strCtryCode != '' && item ? item.v6 : '';
  }

  public getCountryIdByCountryCode(strCtryCode: string = ''): string {
    if (strCtryCode == '') strCtryCode = this.getLoginAsCountryCode();
    let item = this.countryCodes
      ? this.countryCodes.find((x) => x.v2 == strCtryCode)
      : null;
    return strCtryCode && strCtryCode != '' && item ? item.key : '';
  }

  public getCountryCodeByCountryId(strId: string = ''): string {
    if (strId == '')
      strId = this.getCountryIdByCountryCode(this.getLoginAsCountryCode());
    let item = this.countryCodes
      ? this.countryCodes.find((x) => x.key == strId)
      : null;
    return strId && strId != '' && item ? item.v2 : '';
  }

  onGetCurrencyIcon(businessId: string): string {
    let value = '';
    if (this.loggedMember?.businesses) {
      // do {
      const item = this.loggedMember?.businesses?.find(
        (x) => x.key == businessId,
      );
      if (item) {
        value = item.v10;
      }
      // } while (value == '');
    }
    return value;
  }

  replaceAll(
    fullValue: string,
    toReplaceValue,
    replaceWith: string = '',
  ): string {
    var regExp = new RegExp(toReplaceValue, 'g');
    var newStr = fullValue.replace(regExp, replaceWith);
    return newStr;
  }

  public getLoggedMemberName(): KeyValueSet {
    let user = this.loggedMember.loggedMember.content;
    return {
      key: this.getLanguageCode(user.v5),
      value: user.v1,
    } as KeyValueSet;
  }

  onGetUsageLimit(usageLimitType: UsageLimitType): number {
    let rtn = 0;
    let item = this.usageLimits.find((x) => x.key == usageLimitType);
    if (item && item.value != 0) {
      rtn = item.value;
    }
    return rtn;
  }

  GetQrCodeImage(strValue: string, size: number): string {
    let rtn: string = '';
    //var svg_string = QrImage.imageSync(strValue, { type: 'svg', size: size });
    //rtn = svg_string;
    return rtn;
  }

  public getPageKeyName(): KeyValueSet {
    let item: KeyValueSet = { key: '', value: '' } as KeyValueSet;
    let strPageKey = this.currentPageKey.toString();
    this.publicMenus?.forEach((menu) => {
      if (menu && menu.subMenus) {
        menu.subMenus.forEach((subMenu) => {
          if (subMenu.menu.v6 == strPageKey) {
            item.key = menu.menu.v5.replace(
              '/',
              ' ' + this.languageContent.common.or + ' ',
            ); //Parent name;
            item.value = subMenu.menu.v5.replace(
              '/',
              ' ' + this.languageContent.common.or + ' ',
            ); //Submenu name
          }
        });
      }
    });

    if (this.selected.user && item && item.key == '') {
      item.key = 'Admin 1';
      item.key = 'Admin 2';
    }
    return item;
  }

  public redirectToSeller() {
    if (this.selectedMenu)
      this.pageKeyBeforeRedirectToSeller = parseInt(this.selectedMenu.v6);
    this.router.navigate([
      '/sellers',
      this.selected.countryCode,
      this.selected.user,
      InteractionType.Business,
    ]);
  }

  onDirectToServiceProviderCreation() {
    const modalRef = this.modalService.open(MessageComponent);
    modalRef.componentInstance.message =
      this.languageContent.common.no_service_provider;
    modalRef.result.then(
      (result) => {
        this.isAddServiveProvider = true;
        this.router.navigate(['/services' + this.basicParamsString, '0']);
      },
      (error) => {
        this.isAddServiveProvider = true;
        this.router.navigate(['/services' + this.basicParamsString, '0']);
      },
    );
  }

  onBlurPopupOpenedClosed(isOpen: boolean) {
    if (isOpen) this.isPopupBlurEnabled = this.isPopupBlurEnabled + 1;
    else this.isPopupBlurEnabled = this.isPopupBlurEnabled - 1;
  }

  public onSetMarginTopForCurrentPopup(top: number, isPercentage: boolean) {
    setTimeout(() => {
      let elements = document.getElementsByClassName('modal-content');
      if (elements && elements.length > 0) {
        let element = elements[elements.length - 1] as HTMLDivElement;
        element.style.marginTop = top + (isPercentage ? '%' : 'px');
      }
    }, 0);
  }

  onClosePopups() {
    let elements = document.getElementsByClassName('popup_close');
    if (elements && elements.length > 0) {
      for (var i = 0; i < elements.length; i++) {
        let element = elements[i] as HTMLButtonElement;
        if (element) {
          element.click();
        }
      }
    }
  }

  public onSetNonPopup() {
    setTimeout(() => {
      let elements = document.getElementsByClassName('modal-content');
      if (elements && elements.length > 0) {
        let element = elements[elements.length - 1] as HTMLDivElement;
        element.style.boxShadow = 'none';
      }
    }, 0);
  }

  public onShowHideOverLayPopup(isShow: boolean) {
    setTimeout(() => {
      let elements = document.getElementsByClassName('modal-backdrop');
      if (elements && elements.length > 0) {
        let element = elements[0] as HTMLDivElement;
        element.style.display = isShow ? 'block' : 'none';
      }
    }, 0);
  }

  public onGetSummaryType(interactionType): SummaryType {
    let summaryType: SummaryType = SummaryType.None;
    switch (parseInt(interactionType)) {
      case InteractionType.User:
        {
          summaryType = SummaryType.User;
        }
        break;
      case InteractionType.Business:
        {
          summaryType = SummaryType.Business;
        }
        break;
      case InteractionType.ServiceProvider:
        {
          summaryType = SummaryType.ServiceProvider;
        }
        break;
    }
    return summaryType;
  }

  public onGetIcon(interactionType): string {
    let summaryType = this.onGetSummaryType(interactionType);
    let iconName = '';
    switch (summaryType) {
      case SummaryType.User:
        {
          iconName = 'person';
        }
        break;
      case SummaryType.Business:
        {
          iconName = 'domain';
        }
        break;
      case SummaryType.ServiceProvider:
        {
          iconName = 'home_repair_service';
        }
        break;
      case SummaryType.Receipt:
        {
          iconName = 'receipt_long';
        }
        break;
    }
    return iconName;
  }

  getLastUsedSetting(
    lastUsedSettingsType: LastUsedSettingsType,
    businessId?: string,
  ): string {
    if (this.lastUsedSettings) {
      if (businessId) {
        const item = this.lastUsedSettings.find(
          (x) =>
            x.userOrBusinessId == businessId &&
            x.inteactionType == InteractionType.Business &&
            x.keyType == lastUsedSettingsType,
        );
        return item ? item.value : '';
      } else {
        const item = this.lastUsedSettings.find(
          (x) =>
            x.inteactionType == InteractionType.User &&
            x.keyType == lastUsedSettingsType,
        );
        return item ? item.value : '';
      }
    } else return '';
  }

  setSelectedMenu(needDelay = false) {
    if (this.currentPageKey && this.loggedMember) {
      /*this.localService.selectedMenu.key = this.localService.getPageKeyMenu(this.localService.currentPageKey, this.localService.loggedMember.allowedMenus.menus).key;*/
      let selectedMenu = this.getPageKeyMenu(
        this.currentPageKey,
        this.loggedMember.allowedMenus.find(x => x.businessId == this.getSelectedBusinessId())?.menus,
      );
      if (selectedMenu) {
        setTimeout(
          () => {
            let elements = document.getElementsByClassName('selected_menu');
            if (elements) {
              for (var i = 0; i < elements.length; i++) {
                let className = elements[i].className;
                className = className.replace('selected_menu', '');
                elements[i].className = className;
              }
            }
            let element = document.getElementById(
              selectedMenu.key,
            ) as HTMLDivElement;
            if (element)
              element.className = element.className + ' selected_menu';
          },
          needDelay ? 500 : 0,
        );
      }
    }
  }

  public checkBrowser() {
    const agent = window.navigator.userAgent.toLowerCase();
    let isBrwoserElligible = agent.indexOf('webkit') > -1;
    if (!isBrwoserElligible)
      this.showMessage(this.languageContent.common.use_chrome);

    let isMac = agent.indexOf('iphone') > -1 || agent.indexOf('mac') > -1;
    //isMac = true;
    if (isMac) {
      let item = document.getElementsByTagName('head')[0];
      item.innerHTML =
        item.innerHTML +
        "<style>input[type='text'], input[type='number'], input[type='password'], input[type='email'] { padding-top: 0px !important; padding-bottom: 5px !important;}</style>";
    }
  }

  public isBusinessAvailable(strBizId: string) {
    return (
      this.loggedMember &&
      this.loggedMember.businesses &&
      this.loggedMember.businesses.filter(
        (x) => x.key == strBizId && x.v2 == '1' && x.v5 == 'BU',
      ).length > 0
    );
  }

  public isBusinessHasPurchaseEntry(strBizId: string) {
    return (
      this.loggedMember &&
      this.loggedMember.businesses &&
      this.loggedMember.businesses.filter(
        (x) => x.key == strBizId && x.v5 == 'BU' && x.v9 == '1',
      ).length > 0
    );
  }

  public isDedicatedStorageAvailable(strBizId: string) {
    return (
      this.loggedMember &&
      this.loggedMember.businesses &&
      this.loggedMember.businesses.filter(
        (x) => x.key == strBizId && x.v5 == 'BU' && x.v11 == '1',
      ).length > 0
    );
  }

  public getBusinessName(strBizId: string): KeyValueSet {
    const item = this.loggedMember.businesses.find((x) => x.key == strBizId);
    return item
      ? ({ key: this.getLanguageCode(item.v4), value: item.v3 } as KeyValueSet)
      : ({ key: 'en', value: strBizId } as KeyValueSet);
  }


  public getBusinesssIdIfSingle() {
    const items =
      this.loggedMember && this.loggedMember.businesses
        ? this.loggedMember.businesses.filter(
          (x) => x.v2 == '1' && x.v5 == 'BU' && x.v6 == '0',
        )
        : [];
    return items.length == 1 ? items[0].key : '';
  }

  isPopupOpened = false;
  public getId(
    redirectionUrl: string,
    interactionType: InteractionType = this.basicParams.interactionType,
  ) {
    let id = '0';
    switch (interactionType) {
      case InteractionType.Business:
        {
          let items =
            redirectionUrl.indexOf('payments') > -1
              ? this.loggedMember.businesses.filter(
                (x) => x.v2 == '1' && x.v5 == 'BU' && x.v6 == '0',
              )
              : this.loggedMember.businesses.filter(
                (x) => x.v2 == '1' && x.v5 == 'BU' && x.v6 == '0',
              );
          if (items.length > 0) {
            if (items.length > 1) {
              id = '-1';
              if (!this.isPopupOpened) {
                this.isPopupOpened = true;
                const modalRef = this.modalService.open(
                  SelectBusinessComponent,
                );
                modalRef.componentInstance.interactionType = interactionType;
                modalRef.result.then(
                  (result) => {
                    this.isPopupOpened = false;
                    if (result.event == TriggeredEvent.Ok) {
                      redirectionUrl = redirectionUrl.replace(
                        '#businessId#',
                        result.businessId,
                      );
                      this.router.navigate(['/' + redirectionUrl]);
                    }
                  },
                  (error) => {
                    this.isPopupOpened = false;
                  },
                );
              }
            } else {
              id = items[0].key;
            }
          }
        }
        break;
      case InteractionType.ServiceProvider:
        {
          let item = this.loggedMember.businesses.find((x) => x.v5 == 'SP');
          if (item) id = item.key;
        }
        break;
      case InteractionType.User:
        {
          let items = this.loggedMember.businesses.filter(
            (x) => x.v2 == '1' && x.v5 == 'BU' && x.v6 == '0',
          );
          if (items.length > 0) {
            id = '-1';
            if (!this.isPopupOpened) {
              this.isPopupOpened = true;
              const modalRef = this.modalService.open(SelectBusinessComponent);
              modalRef.componentInstance.interactionType = interactionType;
              modalRef.result.then(
                (result) => {
                  this.isPopupOpened = false;
                  if (result.event == TriggeredEvent.Ok) {
                    redirectionUrl = redirectionUrl.replace(
                      '#userOrbusinessId#',
                      result.businessId,
                    );
                    this.router.navigate(['/' + redirectionUrl]);
                  }
                },
                (error) => {
                  this.isPopupOpened = false;
                },
              );
            }
          }
        }
        break;
    }
    return id;
  }

  public isServiceProviderBlocked(isIncludeUser = true): boolean {
    let rtn = false;
    if (this.basicParams) {
      if (
        this.basicParams.interactionType == InteractionType.ServiceProvider ||
        (isIncludeUser &&
          this.basicParams.interactionType == InteractionType.User)
      ) {
        let item = this.loggedMember.businesses.find(
          (x) => x.v6 == '1' && x.v5 == 'SP',
        );
        if (item) rtn = true;
      }
    }
    return rtn;
  }

  public isActionAllowed(action: PageAction): boolean {
    let rtn = false;
    let allowedPageAction = this.allowedPageActions.find(
      (x) => x.pageKey == this.currentPageKey,
    );
    if (allowedPageAction && allowedPageAction.isPageAllowed) {
      rtn = allowedPageAction.allowedActions.indexOf(action) > -1;
    }
    return rtn;
  }

  public isPageAllowed(): boolean {
    let allowedPageAction = this.allowedPageActions.find(
      (x) => x.pageKey == this.currentPageKey,
    );
    return allowedPageAction && allowedPageAction.isPageAllowed;
  }

  public isPageActionLoaded(): boolean {
    return (
      this.allowedPageActions &&
      this.allowedPageActions.filter((x) => x.pageKey == this.currentPageKey)
        .length > 0
    );
  }

  public getEquivalentTitle(code) {
    let id = this.getLanguageId(code);
    return this.getEquivalentTitleById(id);
  }

  public getEquivalentTitleById(id) {
    let item = this.languagesEquivalent
      ? this.languagesEquivalent.find((x) => x.v1 == id)
      : undefined;
    return item ? item.v3 : '';
  }

  public setBasicParamsFromUrl() {
    setTimeout(() => {
      try {
        let url = window.location.href;
        let countryCode = '';
        let userId = '';
        let interactionType = '0';
        if (url && url != '/') {
          let urls = url.split('/');
          if (urls.length > 3) {
            countryCode = urls[4];
            userId = urls[5];
            interactionType = urls[6];
          }
        }

        this.basicParams = {
          countryCode: countryCode,
          userId: userId,
          interactionType: parseInt(interactionType),
        } as LoginAsParam;
        this.basicParamsString =
          '/' +
          this.basicParams.countryCode +
          '/' +
          this.basicParams.userId +
          '/' +
          this.basicParams.interactionType;
      } catch (err) {
        console.log('setBasicParamsFromUrl', err);
      }
    }, 100);
  }

  public setBasicParams(
    countryCode,
    userId,
    interactionType,
    businessId: string | undefined = undefined,
    isShowBusiness = true,
    businessIdAsCustomer: string | undefined = undefined,
  ) {
    if (countryCode && userId && interactionType) {
      this.basicParams = {
        countryCode: countryCode,
        userId: userId,
        interactionType: parseInt(interactionType),
        businessId: businessId && businessId.length > 2 ? businessId : '',
        isShowBusiness: isShowBusiness,
        businessIdAsCustomer:
          businessIdAsCustomer && businessIdAsCustomer.length > 2
            ? businessIdAsCustomer
            : '',
      } as LoginAsParam;
      this.basicParamsString =
        '/' +
        this.basicParams.countryCode +
        '/' +
        this.basicParams.userId +
        '/' +
        this.basicParams.interactionType;
    }
  }

  NullObjectId: string | undefined = undefined;
  public ToSelectedLocation(dt?: KeyValues5): SelectedLocation | undefined {
    let rtn: SelectedLocation | undefined = undefined;
    rtn = !dt
      ? undefined
      : ({
        CountryCode: dt.key,
        CountryId: dt.v1 ? dt.v1 : this.NullObjectId,
        StateId: dt.v2 ? dt.v2 : this.NullObjectId,
        DistrictId: dt.v3 ? dt.v3 : this.NullObjectId,
        ConstituencyId: dt.v4 ? dt.v4 : this.NullObjectId,
        PostalCode: dt.v5 ? dt.v5.trim() : '',
      } as SelectedLocation);
    return rtn;
  }

  public setBasicParamCustomerBusiness(businessIdAsCustomer = '') {
    this.basicParams.businessIdAsCustomer = businessIdAsCustomer;
  }

  getPageKeyMenu(pageKey: PageKey, publicMenus: Menus[]): KeyValues10 {
    let strPageKey = pageKey.toString();
    let item: KeyValues10;
    if (publicMenus) {
      publicMenus.forEach((menu) => {
        if (!item) {
          if (menu.menu.v6 == strPageKey) {
            item = menu.menu;
          }
          if (!item && menu && menu.subMenus) {
            menu.subMenus.forEach((subMenu) => {
              if (subMenu && subMenu.menu.v6 == strPageKey) {
                item = subMenu.menu;
              }
            });
          }
        }
      });
    }
    return item;
  }

  public toUtcDateTime(date: string) {
    let dateTime = new Date(date).toUTCString().split(' ');
    let time = dateTime[4].split(':');
    let hrs = parseInt(time[0]);
    let amPm = hrs >= 12 ? 'PM' : 'AM';
    hrs = hrs >= 12 ? hrs - 12 : hrs;
    if (hrs == 0 && amPm == 'PM') hrs = 12;
    return (
      dateTime[1] +
      '-' +
      dateTime[2] +
      '-' +
      dateTime[3] +
      ' ' +
      (hrs > 9 ? '' : '0') +
      hrs +
      ':' +
      time[1] +
      ' ' +
      amPm
    );
  }

  public getLanguageCode(strLanguageId?: string) {
    if (strLanguageId) {
      const language = this.languages
        ? this.languages.find((x) => x.key == strLanguageId)
        : undefined;
      return language ? language.v1 : (this.selectedLanguageCode ?? 'en');
    } else {
      return 'en';
    }
  }

  public getLanguageId(code: string) {
    let language = this.languages
      ? this.languages.find((x) => x.v1 == code)
      : undefined;
    return language ? language.key : '';
  }

  public getSelectedLanguageId(): string {
    const item = this.languages
      ? this.languages.find((x) => x.v1 == this.selectedLanguageCode)
      : undefined;
    return item ? item.key : '';
  }

  public getText(items: KeyValueSet[], key: string | number): string {
    let item = items ? items.find((x) => x.key == key) : undefined;
    return item ? item.value : '-';
  }

  public getDateFromRange(
    dateTime: KeyValues10,
    addDaysForToday: number,
    addHoursForPlanned: number,
  ) {
    let isToday = dateTime.v1 == '1';
    let date = dateTime.v2;
    let time = dateTime.v3;
    let dates: number[] = isToday
      ? []
      : date.split('-').map((x) => parseInt(x));
    let times: number[] = isToday
      ? []
      : time
        .split(' ')[0]
        .split(':')
        .map((x) => parseInt(x));
    let newDate: Date = isToday
      ? this.getDeviceDate()
      : new Date(
        dates[2],
        dates[1],
        dates[0],
        times[0] + (time.indexOf('pm') > -1 ? 12 : 0),
        times[1],
      );
    let updatedDate: Date = isToday
      ? this.addDays(newDate, addDaysForToday)
      : this.addHours(newDate, addHoursForPlanned);
    return updatedDate;
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  addHours(date: Date, hours: number): Date {
    date.setHours(date.getHours() + hours);
    return date;
  }

  public getDecodedQrCode(qrCodeInput: string): DecodedQrCode {
    let rtn = { isValid: false, rawData: qrCodeInput } as DecodedQrCode;
    if (
      qrCodeInput.startsWith(this.localBarCodePrefix + this.barcodeSplitChar) &&
      qrCodeInput.endsWith(this.barcodeSplitChar + this.localBarCodeSufffix)
    ) {
      let qrCodes = qrCodeInput.split(this.localBarCodePrefix);
      if (qrCodes.length > 0) {
        let keys = qrCodes[1].split(this.barcodeSplitChar);
        if (keys.length >= 3) {
          rtn.barCodeCategory = parseInt(keys[1]);
          rtn.value = keys[2];
          rtn.quantity = keys[3] ? parseInt(keys[3]) : 0;
          rtn.isInternalBarCode = true;
          rtn.isValid = true;
        }
      }
    } else if (
      qrCodeInput.indexOf(this.barCodePrefix + this.barcodeSplitChar) > -1
    ) {
      let qrCodes = qrCodeInput.split(this.barCodePrefix);
      if (qrCodes.length > 0) {
        let keys = qrCodes[1].split(this.barcodeSplitChar);
        if (keys.length >= 7) {
          rtn.countryCode = keys[1];
          rtn.barCodeCategory = parseFloat(keys[2]);
          rtn.value = keys[3];
          rtn.quantity = keys[4] ? parseFloat(keys[4]) : 0;
          rtn.businessId =
            rtn.barCodeCategory == BarCodeCategory.Business
              ? rtn.value
              : keys[5];
          rtn.productId = keys[6];
          rtn.interactionType = parseInt(keys[7]);
          rtn.isInternalBarCode = false;
          rtn.isValid = true;
        }
      }
    }
    return rtn;
  }

  public copyContent(strVal: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = strVal;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.showInformation(this.languageContent.common.copied);
  }

  public showImage(strImageId: string, url?: string) {
    if (strImageId != '') {
      const modalRef = this.modalService.open(ViewImageComponent);
      modalRef.componentInstance.id = strImageId;
      modalRef.componentInstance.url = url;
    }
  }

  public setDirectUrlSelected() {
    const countryCodes = this.basicParams.countryCode.split('-');
    this.selected.countryCode = countryCodes.length > 0 ? countryCodes[0] : '';
    this.selected.user = this.basicParams.userId;
    this.selected.token = '';
  }

  public getDeviceDate(): Date {
    const localDatePipe = new LocalDatePipe();
    return localDatePipe.getDeviceDate();
  }

  public getDeviceDateWithFormat(
    format: string = 'DD-MMM-YYYY hh:mm A',
  ): string {
    const localDatePipe = new LocalDatePipe();
    return localDatePipe.getDeviceDateWithFormat(format);
  }

  public getUtcOffset(): number {
    const localDatePipe = new LocalDatePipe();
    return localDatePipe.getUtcOffset();
  }

  public getSelected(languageCode?: string, countryCode?: string): KeyValues15 {
    const localDatePipe = new LocalDatePipe();
    let timeDifference = localDatePipe.getLocalTimeDifference();
    if (this.selected) {
      return {
        v1: this.selected.countryCode,
        v2: languageCode
          ? this.getLanguageId(languageCode)
          : this.selected.applicationLanguage,
        v3: this.selected.token,
        v4: this.selected.user,
        v5: this.languages ? this.languages.find((x) => x.v1 == 'en').key : '',
        v6: localDatePipe.getDeviceDate().toString(),
        v7: countryCode ?? this.getLoginAsCountryCode(),
        v8: this.basicParams && this.basicParams.userId ? this.basicParams.userId : '',
        v9: this.basicParams && this.basicParams.interactionType ? this.basicParams.interactionType.toString() : '',
        v10: timeDifference[0].toString(),
        v11: timeDifference[1].toString(),
        v12: localDatePipe.getUtcOffset().toString(),
        v13: this.viewAsReturnCountryCodeUserId ? '1' : '0',
      } as KeyValues15;
    } else {
      return {
        v1: null,
        v2: null,
        v3: null,
        v4: null,
        v5: null,
        v6: localDatePipe.getDeviceDate().toString(),
        v7: countryCode ?? '',
        v10: timeDifference[0].toString(),
        v11: timeDifference[1].toString(),
        v12: localDatePipe.getUtcOffset().toString(),
      } as KeyValues15;
    }
  }

  public getLoginAsCountryCode(): string {
    const countryCodes = this.basicParams && this.basicParams.countryCode
      ? this.basicParams.countryCode.split('-')
      : [this.selected.countryCode];
    const countryCode = countryCodes.length > 0 ? countryCodes[0] : '';
    const asCtrCode = countryCodes.length > 1 ? countryCodes[1] : countryCode;
    return asCtrCode;
  }

  public getCurencyCode(ctryCode?: string): string {
    return (ctryCode ?? this.getLoginAsCountryCode()).toLowerCase() == 'ind'
      ? '&#8377;'
      : '&#36;';
  }

  public onGetReceiptOptionContainsText(key: number): string {
    return ReceiptOptionContains[key];
  }

  public getLastPagingSetup(pagingType: number): Paging {
    let item = this.lastPageSetup.find(
      (x) =>
        x.userId == this.loggedMember.loggedMember.content.key &&
        x.pageType == pagingType,
    );
    return item ? item.paging : null;
  }

  public getLastPagingSetupAdditionalFilter(pagingType: number): Paging {
    let item = this.lastPageSetup.find(
      (x) =>
        x.userId == this.loggedMember.loggedMember.content.key &&
        x.pageType == pagingType,
    );
    return item ? item.additionalFilter : null;
  }

  public onUpdateAdditionalFilters(pagingType: number, data: any) {
    let item = this.lastPageSetup.find(
      (x) =>
        x.userId == this.loggedMember.loggedMember.content.key &&
        x.pageType == pagingType,
    );
    if (item) item.additionalFilter = data;
    else
      this.lastPageSetup.push({
        userId: this.loggedMember.loggedMember.content.key,
        pageType: pagingType,
        paging: null,
        additionalFilter: data,
      } as LastPagingSetup);
  }

  onRefreshBusiness() {
    if (this.selected && this.selected.user) {
      const elements = document.getElementsByClassName('on-login');
      for (var i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLButtonElement;
        element.click();
      }
    }
  }

  getSelectedBusinessId(): string {
    if (this.basicParams && this.basicParams.businessId && this.loggedMember?.allowedMenus?.find(x => x.businessId == this.basicParams.businessId)) {
      return this.basicParams.businessId;
    } else if (this.loggedMember?.allowedMenus?.length > 0) {
      return this.loggedMember.allowedMenus[0].businessId;
    } else {
      return "";
    }
  }

  getAvailableConnectionForWeighMachine(): WeightMachineConnetion[] {
    const deviceSettings = this.loggedMember?.deviceSettings;
    const connections: WeightMachineConnetion[] = [];
    if (deviceSettings) {
      deviceSettings.forEach(deviceSetting => {
        if (deviceSetting.IsEnableWeightMachine) {
          const networkUrl = deviceSetting.NetworkWeightMachineNameId && deviceSetting.NetworkWeightMachineNameId.length > 5 ? this.loggedMember.weightMachines?.find(x => x.Id == deviceSetting.NetworkWeightMachineNameId) : undefined;

          connections.push({
            businessId: deviceSetting.BusinessId,
            directUrl: deviceSetting.DirectPrintUrl,
            networkUrl: networkUrl?.BusinessId ?? '',
            portPath: networkUrl?.WeightMachineName ?? ''
          });
        }
      });
    }
    return connections;
  }

  getCustomerCopiesTemplateIds(): string[] {
    const businessId = this.getSelectedBusinessId();
    return this.loggedMember?.receiptTemplates?.filter(x => x.businessId == businessId && x.isCustomerCopy == true)?.map(x => x.id) ?? [];
  }

  public setLoggedMember(loggedMember: LoggedMemberWrapper) {
    this.loggedMember = loggedMember;
    this.languagesEquivalent = this.loggedMember.allowedMenus.find(x => x.businessId == this.getSelectedBusinessId())?.equivalent;
    this.selected.user = loggedMember.loggedMember.content.key;
    this.selected.token = loggedMember.loggedMember.content.v10;
    this.lastUsedSettings = loggedMember.used;
    const businessDeviceIds = loggedMember.deviceSettings?.map(x => {
      return {
        key: x.BusinessId,
        value: x.Id
      } as KeyValueSet
    });

    this.setLastDeviceSettings(this.loggedMember.loggedMember.content.v9, businessDeviceIds);

    if (this.redirectUrlAfterLogin && this.redirectUrlAfterLogin.length > 2) {
      this.router.navigate(['/' + this.redirectUrlAfterLogin]);
      this.redirectUrlAfterLogin = '';
    } else if (
      this.redirectUrl &&
      this.redirectUrl.startsWith(this.barCodePrefix)
    ) {
      this.router.navigate([
        '/qrcode',
        this.selected.countryCode,
        this.selected.user,
        0,
      ]);
    } else if (this.redirectUrl) {
      this.router.navigate([this.redirectUrl]);
      this.redirectUrl = '';
    } else {
      if (this.loggedMember.loggedMember.content.v4) {
        let lastUsedUrl = this.getLastUsedSetting(
          LastUsedSettingsType.VisitedURL,
        );
        if (this.selectedMenu) {
          if (this.selectedMenu.v4.split('#').length == 3) {
            this.router.navigate(['/' + lastUsedUrl]);
          }
          let menu = document.getElementById('menu') as HTMLElement;
          menu.click();
          setTimeout(() => {
            let menuOption = document.getElementById(
              this.selectedMenu.key,
            ) as HTMLElement;
            menuOption.click();
          }, 5);
        } else {
          if (lastUsedUrl == '')
            this.router.navigate([
              '/qrcode',
              this.selected.countryCode,
              this.selected.user,
              0,
            ]);
          else this.router.navigate(['/' + lastUsedUrl]);
        }
      } else {
        this.router.navigate([
          '/user',
          this.selected.countryCode,
          this.selected.user,
          1,
        ]);
      }
    }
  }

  onNavigateToPage(pageKey) {
    this.navigateToPage = parseInt(pageKey);
    let element = document.getElementById('on_page_key_pressed') as HTMLElement;
    if (element) element.click();
  }

  getTopForAddNew(): number {
    let height = 75;
    let width = 0;
    let elements = document.getElementsByClassName('footer');
    if (elements && elements.length > 0) {
      for (var i = 0; i < elements.length; i++) {
        let element = elements[i] as HTMLDivElement;
        width = width + element.clientWidth;
        height = height + element.offsetHeight;
      }
    }

    let elementsCurrent = document.getElementsByClassName('footer_add_new');
    let widthCurrent = 0;
    if (elementsCurrent && elementsCurrent.length > 0) {
      for (var i = 0; i < elementsCurrent.length; i++) {
        let element = elementsCurrent[i] as HTMLDivElement;
        widthCurrent = widthCurrent + element.clientWidth;
      }
    }
    return width >= window.innerWidth - widthCurrent ? height : 50;
  }

  public onOpenUi(openUi: OpenUi) {
    setTimeout(() => {
      let element: HTMLElement = null;
      switch (openUi) {
        case OpenUi.Calender:
          {
            let elements = document.getElementsByClassName('dp-popup');
            if (elements && elements.length > 0) {
              element = elements[0].parentElement;
            }
          }
          break;
      }
      if (element) {
        let currentLeft = parseFloat(element.style.left.replace('px', ''));
        if (currentLeft <= 0) {
          //currentLeft = parseFloat(currentLeft.toString().replace('-', ''));
          element.style.left = '2px';
        }
      }
    }, 5);
  }

  public saveUrl() {
    let url = this.router.url;
    if (
      !(
        url == '' ||
        url == '/' ||
        this.menusWithoutLogin.filter((x) => url.indexOf(x) > -1).length > 0
      ) &&
      !this.selected.user
    ) {
      this.router.navigate(['/']);
    }
    let element = document.getElementById('last_url_save') as HTMLElement;
    if (element) element.click();
  }

  //Collection of FocusInputType
  public getHeightOfOpenedControls(inputs: string): number {
    let inputValues = inputs.split(',').map((x) => parseInt(x));
    let value = 0;
    inputValues.forEach((x) => {
      value = value + this.getHeightOfOpenedControl(x);
    });
    return value;
  }

  public getHeightOfOpenedControl(inputType: FocusInputType): number {
    let elements = null;
    switch (inputType) {
      case FocusInputType.NgxDropDown:
        {
          elements = document.getElementsByClassName('ngx-select__choices');
        }
        break;
      case FocusInputType.Calendar:
        {
          elements = document.getElementsByTagName('ngb-datepicker');
        }
        break;
    }
    return elements && elements.length > 0 ? elements[0].clientHeight : 0;
  }

  public onLogout() {
    if (this.selected.user != '') {
      this.selected.user = '';
      this.loggedMember = undefined;
      this.receiptPrintDatas = [];
      this.userDevicePrinterSetupWrapper = {
        devicePrinterSetups: [],
        printerTemplateOffline: [],
      } as DevicePrinterSetupWrapper;
      this.businesesPrinterSetup = [];
      this.allowedPageActions = [];
      this.businessRoleForUsers = [];
      //this.lastUsedSettings = [];
      this.selectedMenu = null;
      this.basicParams = null;
      this.basicParamsString = '';
      this.router.navigate(['/']);
    }
  }

  public splitString(data: string): string[] {
    return data.split('\n');
  }

  public getModalPopupDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public showMessage(
    strMessage: string,
    header = '',
    isHtmlMessage: boolean = false,
  ) {
    if (strMessage != '') {
      const modalRef = this.modalService.open(MessageComponent);
      modalRef.componentInstance.header = header;
      modalRef.componentInstance.message = strMessage;
      modalRef.componentInstance.IsHtmlMessage = isHtmlMessage;
    }
  }

  public showMessageByStatus(status: Status) {
    this.showMessage(this.getTextByStatus(status));
  }

  public getTextByStatus(status: Status): string {
    let statusTxt = '';
    switch (status) {
      case Status.SuccessWithMoreAction:
      case Status.Success:
        {
          statusTxt = this.languageContent.status.success;
        }
        break;
      case Status.Running:
        {
          statusTxt = this.languageContent.status.running_bg;
        }
        break;
      case Status.NotAllowed:
        {
          statusTxt = this.languageContent.status.not_allowed;
        }
        break;
      case Status.DataRequired:
        {
          statusTxt = this.languageContent.status.data_required;
        }
        break;
      case Status.Duplicate:
        {
          statusTxt = this.languageContent.status.duplicate;
        }
        break;
      case Status.MinimumRequired:
        {
          statusTxt = this.languageContent.status.min_required;
        }
        break;
      case Status.LimitExceeded:
        {
          statusTxt = this.languageContent.status.limit_exceeded;
        }
        break;
      case Status.NotFound:
      case Status.UnAvailable:
        {
          statusTxt = this.languageContent.status.unavailable;
        }
        break;
      case Status.ErrorOccured:
        {
          statusTxt = this.languageContent.status.error_occured;
        }
        break;
      case Status.RangeNotAllowed:
        {
          statusTxt = this.languageContent.status.range_not_allowed;
        }
        break;
      case Status.InUse:
        {
          statusTxt = this.languageContent.status.in_use;
        }
        break;
      case Status.InventoryRequired:
        {
          statusTxt = this.languageContent.status.inventory_required;
        }
        break;
      case Status.NeedPrimarySelection:
        {
          statusTxt = this.languageContent.status.need_primary_selection;
        }
        break;
      case Status.Invalid:
        {
          statusTxt = this.languageContent.status.invalid;
        }
        break;
      case Status.Failed:
        {
          statusTxt = this.languageContent.status.failed;
        }
        break;
    }
    return statusTxt;
  }

  public showSummary(strId: string | number, summaryType: SummaryType) {
    if (strId) {
      const modalRef = this.modalService.open(SummaryComponent, {
        size: summaryType == SummaryType.Guide ? 'xl' : '',
      });
      modalRef.componentInstance.id = strId;
      modalRef.componentInstance.summaryType = summaryType;
      modalRef.componentInstance.ctryCode = '';
    }
  }

  public showSummaryWithCtry(
    strId: string | number,
    summaryType: SummaryType,
    ctryCode: string = '',
  ) {
    if (strId) {
      if (!(ctryCode && ctryCode.length > 0)) {
        ctryCode = this.getLoginAsCountryCode();
      }
      const modalRef = this.modalService.open(SummaryComponent, {
        size: summaryType == SummaryType.Guide ? 'xl' : '',
      });
      modalRef.componentInstance.id = strId;
      modalRef.componentInstance.summaryType = summaryType;
      modalRef.componentInstance.ctryCode = ctryCode;
    }
  }

  public onDownloadFile(
    data: any,
    fileName: string = '',
    fileType: FileType = FileType.XLSX,
    excelDownloadTemplateType: ExcelDownloadTemplateType = ExcelDownloadTemplateType.None,
  ) {
    if (
      excelDownloadTemplateType != ExcelDownloadTemplateType.None &&
      fileName.trim().length == 0
    ) {
      switch (excelDownloadTemplateType) {
        case ExcelDownloadTemplateType.BulkSerialNumbers:
          {
            fileName = 'SerialNumbers';
          }
          break;
        case ExcelDownloadTemplateType.BulkUsers:
          {
            fileName = 'Users';
          }
          break;
        default:
          {
            fileName = 'Data';
          }
          break;
      }
    }

    switch (environment.service_type) {
      case ServiceType.DotNet:
        {
          let url = window.URL.createObjectURL(data);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          if (fileName == '') fileName = this.getRandomString(6);
          a.download = fileName + fileType;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
        break;
      default:
        {
          this.fileSaveService.SaveFile(data, fileName, fileType);
        }
        break;
    }
  }

  onGetCustomBodyHeight(
    iAdjustAdditionalHeight: number = 0,
    isPopupModal = false,
  ): number {
    if (!iAdjustAdditionalHeight) iAdjustAdditionalHeight = 0;
    if (isPopupModal) {
      return this.onGetMaxModalBodyHeight(iAdjustAdditionalHeight);
    } else {
      let height = 40;
      let elements = document.getElementsByClassName('freeze_height');
      if (elements != undefined && elements != null && elements.length > 0) {
        for (var i = 0; i < elements.length; i++) {
          let element = elements[i] as HTMLDivElement;
          height = height + element.offsetHeight;
        }
      }
      return (
        window.innerHeight -
        (height + iAdjustAdditionalHeight)
      );
    }
  }

  onGetMaxModalBodyHeight(iAdjustAdditionalHeight: number = 0) {
    if (!iAdjustAdditionalHeight) iAdjustAdditionalHeight = 0;
    let height = 30;
    let elements = document.getElementsByClassName('modal-header');
    if (elements != undefined && elements != null && elements.length > 0) {
      for (var i = 0; i < elements.length; i++) {
        let element = elements[i] as HTMLDivElement;
        height = height + element.offsetHeight;
      }
    }

    elements = document.getElementsByClassName('modal-footer');
    if (elements != undefined && elements != null && elements.length > 0) {
      for (var i = 0; i < elements.length; i++) {
        let element = elements[i] as HTMLDivElement;
        height = height + element.offsetHeight;
      }
    }
    return window.innerHeight - (height + iAdjustAdditionalHeight) - 50;
  }

  lastUsedLanguageCacheKey = 'lazydigisol_is_language_selected';
  getLastLanguageSelecetd(): boolean {
    return (
      localStorage.getItem(this.lastUsedLanguageCacheKey) != null &&
      localStorage.getItem(this.lastUsedLanguageCacheKey) == 'true'
    );
  }

  setLastLanguageSelecetd() {
    localStorage.setItem(this.lastUsedLanguageCacheKey, 'true');
  }

  lastDeviceSettingsCacheKey = 'pnixsoft_last_device_settings';
  getLastDeviceSettings(phoneNumber: string): KeyValueId[] {
    try {
      const key = this.lastDeviceSettingsCacheKey + '_' + phoneNumber;
      if (localStorage.getItem(key) != null) {
        return JSON.parse(localStorage.getItem(key)) as KeyValueId[];
      } else {
        return [] as KeyValueId[];
      }
    } catch {
      return [] as KeyValueId[];
    }
  }

  setLastDeviceSettings(phoneNumber: string, deviceSettings: KeyValueId[]) {
    const key = this.lastDeviceSettingsCacheKey + '_' + phoneNumber;
    localStorage.setItem(key, JSON.stringify(deviceSettings));
  }

  lastUsedCacheKey = 'lazydigisol_last_user';
  getLastUser(): KeyValueSet {
    try {
      if (this.viewAsCountryCodeUserId || this.viewAsReturnCountryCodeUserId) {
        return (
          this.viewAsCountryCodeUserId ?? this.viewAsReturnCountryCodeUserId
        );
      } else {
        if (localStorage.getItem(this.lastUsedCacheKey) != null) {
          let item = JSON.parse(
            this.decryptCrypto(localStorage.getItem(this.lastUsedCacheKey)),
          ) as KeyValueSet;
          this.isEnableAutoLoginNextTime = item.isSelected;
          return item;
        } else {
          return { key: '', value: '' } as KeyValueSet;
        }
      }
    } catch {
      return { key: '', value: '' } as KeyValueSet;
    }
  }

  setLastUser(userId?: string, loginWithCountryAndPhoneNumber?: string) {
    if (!this.viewAsCountryCodeUserId && !this.viewAsReturnCountryCodeUserId) {
      if (loginWithCountryAndPhoneNumber) {
        this.loginWithCountryAndPhoneNumber = loginWithCountryAndPhoneNumber;
      }
      let item = {
        key: this.selected.countryCode,
        value: userId ?? this.selected.user,
        isSelected: this.isEnableAutoLoginNextTime,
      } as KeyValueSet;
      localStorage.setItem(
        this.lastUsedCacheKey,
        this.encryptCrypto(JSON.stringify(item)),
      );
    }

    if (
      !this.viewAsCountryCodeUserId &&
      this.viewAsReturnCountryCodeUserId &&
      this.viewAsReturnCountryCodeUserId.value == this.selected.user
    ) {
      this.viewAsReturnCountryCodeUserId = null;
    }
  }

  lastCameraCacheKey = 'pnixsoft_last_camera';
  getLastCamera(): KeyValueSet {
    if (localStorage.getItem(this.lastCameraCacheKey) != null) {
      return JSON.parse(localStorage.getItem(this.lastCameraCacheKey));
    } else {
      return { key: '', value: '' } as KeyValueSet;
    }
  }

  setLastCamera(deviceId: string) {
    let item = { key: '', value: deviceId } as KeyValueSet;
    localStorage.setItem(this.lastCameraCacheKey, JSON.stringify(item));
  }

  lastMenuCollapsedCacheKey = 'last_menu_collapsed';
  lastMenuHiddenCacheKey = 'last_menu_hidden';
  public getMenuCollapsed() {
    if (localStorage.getItem(this.lastMenuCollapsedCacheKey) != null) {
      this.collapsedMenu = JSON.parse(
        localStorage.getItem(this.lastMenuCollapsedCacheKey),
      );
    } else {
      this.collapsedMenu = [];
    }
  }

  public getMenuHidden() {
    if (localStorage.getItem(this.lastMenuHiddenCacheKey) != null) {
      this.hiddenMenu = JSON.parse(
        localStorage.getItem(this.lastMenuHiddenCacheKey),
      );
    } else {
      this.hiddenMenu = [];
    }
  }

  public info = '';
  public isRedAlert = false;
  showInformation(
    message: string,
    isRedAlert = false,
    fadeOutSeconds: number = 3,
  ) {
    if (message != '') {
      this.info = message;
      this.isRedAlert = isRedAlert;
      setTimeout(() => {
        this.info = '';
        this.isRedAlert = false;
      }, fadeOutSeconds * 1000);
    }
  }

  showInformationByStatus(status: Status, isRedAlert = false) {
    this.showInformation(this.getTextByStatus(status), isRedAlert);
  }

  public setMenuCollapsed() {
    localStorage.setItem(
      this.lastMenuCollapsedCacheKey,
      JSON.stringify(this.collapsedMenu),
    );
  }

  public setMenuHidden() {
    localStorage.setItem(
      this.lastMenuHiddenCacheKey,
      JSON.stringify(this.hiddenMenu),
    );
  }

  public getOnlyInteger(strValue: string): number {
    let temp = '';
    for (var i = 0; i < strValue.length; i++) {
      if (this.intValues.indexOf(strValue[i]) > -1) {
        temp = temp + strValue[i];
      }
    }
    return temp != '' ? parseInt(temp) : null;
  }

  onSetInput(id: string, inputType: FocusInputType, inputValue = '') {
    switch (inputType) {
      case FocusInputType.TextBox:
        {
          let element: HTMLInputElement = document.getElementById(
            id,
          ) as HTMLInputElement;
          if (element) {
            element.value = inputValue;
          }
        }
        break;
      case FocusInputType.NgxDropDown:
        {
          let element: HTMLDivElement = document.getElementById(
            id,
          ) as HTMLDivElement;
          if (element) {
            let elementToFocus = element.getElementsByClassName('ngx-select');
            if (elementToFocus && elementToFocus.length > 0) {
              let toFocus: HTMLInputElement =
                elementToFocus[0].getElementsByTagName(
                  'input',
                )[0] as HTMLInputElement;
              if (toFocus) {
                toFocus.value = inputValue;
              }
            }
          }
        }
        break;
    }
  }

  onFocusNextInput(
    nextFocusId: string,
    nextfocusInputType: FocusInputType,
    isSelectValue = false,
    isTimeDelayRequired = false,
  ) {
    setTimeout(
      () => {
        switch (nextfocusInputType) {
          case FocusInputType.TextBox:
            {
              let element: HTMLInputElement = document.getElementById(
                nextFocusId,
              ) as HTMLInputElement;
              if (element) {
                if (isSelectValue) element.select();
                else {
                  let value = element.value;
                  element.value = '';
                  element.focus();
                  element.value = value;
                }
              }
            }
            break;
          case FocusInputType.NgxDropDown:
            {
              let element: HTMLDivElement = document.getElementById(
                nextFocusId,
              ) as HTMLDivElement;
              if (element) {
                let elementToFocus =
                  element.getElementsByClassName('ngx-select');
                if (elementToFocus && elementToFocus.length > 0) {
                  if (isSelectValue) {
                    let elementToClick = element.getElementsByClassName(
                      'ngx-select__item_active',
                    );
                    if (elementToClick && elementToClick.length > 0) {
                      let toClick: HTMLDivElement =
                        elementToClick[0] as HTMLDivElement;
                      toClick.click();
                    }
                  } else {
                    let toFocus: HTMLDivElement =
                      elementToFocus[0] as HTMLDivElement;
                    toFocus.focus();
                    let elementToClick = element.getElementsByClassName(
                      'ngx-select__toggle-buttons',
                    );
                    if (elementToClick && elementToClick.length > 0) {
                      let toClick: HTMLDivElement =
                        elementToClick[0] as HTMLDivElement;
                      toClick.click();
                    }
                  }
                }
              }
            }
            break;
          case FocusInputType.CheckBox:
          case FocusInputType.RadioButton:
            {
              let element: HTMLInputElement = document.getElementById(
                nextFocusId,
              ) as HTMLInputElement;
              if (element) {
                element.click();
              }
            }
            break;
          case FocusInputType.Button:
            {
              let element: HTMLButtonElement = document.getElementById(
                nextFocusId,
              ) as HTMLButtonElement;
              if (element) {
                element.focus();
                if (isSelectValue) element.click();
              }
            }
            break;
        }
      },
      isTimeDelayRequired ? 500 : 0,
    );
  }

  onAutoLogin() {
    let lastUser = this.getLastUser();
    if (lastUser && lastUser.key && lastUser.isSelected) {
      this.onFocusNextInput('btn_login_logout', FocusInputType.Button, true);
    }
  }

  onLogin() {
    if (!this.selected || !this.selected.user) {
      this.onFocusNextInput('btn_login_logout', FocusInputType.Button, true);
    }
  }

  onFocusFooterDropDown(
    button_id: string,
    dropdown_id: string,
    id_to_select: string = '',
    isAdjustmentNeeded = true,
  ) {
    this.onFocusNextInput(dropdown_id, FocusInputType.NgxDropDown);
    if (isAdjustmentNeeded) {
      setTimeout(() => {
        let element = document.getElementById(button_id) as HTMLButtonElement;
        let elementDd = document.getElementById(dropdown_id) as HTMLDivElement;
        if (elementDd) {
          let left = 0;
          let elementDds = document.getElementsByClassName('freeze_height');
          if (elementDds && elementDds.length > 0) {
            for (var i = 0; i < elementDds.length; i++) {
              let elementDdTemp = elementDds[i] as HTMLDivElement;
              if (elementDdTemp) {
                left += elementDdTemp.offsetLeft;
              }
            }
          }
          let rightAvailable =
            document.body.clientWidth - element.offsetLeft - left;
          let minLeft = 200;
          elementDd.style.left =
            rightAvailable > minLeft
              ? element.offsetLeft + 'px'
              : element.offsetLeft - minLeft + 'px';
          let elementOptions =
            elementDd.getElementsByClassName('ngx-select__item');
          let elementsActive = elementDd.getElementsByClassName(
            'ngx-select__item_active',
          );
          if (
            elementOptions.length > 1 &&
            elementsActive.length > 0 &&
            id_to_select != ''
          ) {
            elementsActive[0].className = elementOptions[1].className;
            let elementToActive = document.getElementById(id_to_select);
            setTimeout(() => {
              elementToActive.parentElement.className =
                elementToActive.parentElement.className +
                ' ngx-select__item_active';
              let elementList = elementDd.getElementsByClassName(
                'ngx-select__choices',
              );
              if (elementList.length > 0) {
                let listElement =
                  elementToActive.parentElement as HTMLAnchorElement;
                listElement.focus();
              }
            }, 10);
          }
        }
      }, 1);
    }
  }

  decimalKeyPressedIds: string[] = [];
  isNumberOnly(event, config?: NumericConfig): boolean {
    const charCode = event.which ? event.which : event.keycode;
    if (!config) {
      config = {
        isDecimalAllowed: false,
        maxValue: null,
        maxDigits: null,
        navigateToNextIdIfMaxDigitReached: '',
        isNegativeAllowed: false,
        isStartWithZeroAllowed: false,
        maxDecimalDigits: 2,
      } as NumericConfig;
    } else {
      if (!config.isDecimalAllowed) config.isDecimalAllowed = false;
      if (!config.maxValue) config.maxValue = null;
      if (!config.maxDigits) config.maxDigits = null;
      if (!config.navigateToNextIdIfMaxDigitReached)
        config.navigateToNextIdIfMaxDigitReached = '';
      if (!config.isNegativeAllowed) config.isNegativeAllowed = false;
      if (!config.isStartWithZeroAllowed) config.isStartWithZeroAllowed = false;
      if (!config.maxDecimalDigits) config.maxDecimalDigits = 2;
    }
    if (config.isNegativeAllowed && charCode == 45) return true;
    if (!config.isNegativeAllowed && charCode == 45) return false;

    if (
      config.isStartWithZeroAllowed &&
      charCode == 48 &&
      (!event.target.value ||
        (event.target.value && event.target.value.toString().length == 0))
    ) {
      return true;
    }

    if (
      config.isDecimalAllowed &&
      event.target.id &&
      (!event.target.value ||
        (event.target.value && event.target.value.toString().indexOf('.') > -1))
    ) {
      this.decimalKeyPressedIds = this.decimalKeyPressedIds.filter(
        (x) => x != event.target.id,
      );
    }
    if (config.maxValue != null && config.maxValue == 0)
      config.maxValue = this.maxIntegerLength;

    let isSelectionRemoved = false;
    if (document.getSelection().type == 'Range') {
      document.getSelection().deleteFromDocument();
      isSelectionRemoved = true;
    }

    if (
      config.isDecimalAllowed &&
      charCode == 46 &&
      (!event.target.value ||
        (event.target.value &&
          parseFloat(event.target.value) < config.maxValue &&
          event.target.value.indexOf('.') == -1))
    ) {
      if (event.target.id) this.decimalKeyPressedIds.push(event.target.id);
      return true;
    }
    if (
      config.isDecimalAllowed &&
      event.target.value &&
      event.target.value == '0' &&
      event.key == '0'
    )
      return false;
    if (
      !config.isDecimalAllowed &&
      ((!event.target.value && event.key == '0') ||
        (event.target.value && event.target.value == '' && event.key == '0'))
    )
      return false;
    if (
      charCode == 46 &&
      !config.isDecimalAllowed &&
      charCode > 31 &&
      (charCode < 48 || charCode > 57)
    ) {
      return false;
    }

    if (
      config.isDecimalAllowed &&
      event.target.value &&
      event.target.value.toString().includes('.')
    ) {
      let temp = event.target.value.toString().split('.');
      if (temp[1].length >= config.maxDecimalDigits) {
        return false;
      }
    }

    if (
      !isSelectionRemoved &&
      event.target.value &&
      event.which != 46 &&
      config.maxValue != null
    ) {
      let currentValue: string = event.target.value.toString();
      if (currentValue.indexOf('.') > -1) {
        let values = currentValue.split('.');
        if (values.length > 1 && values[1].length >= 2) return false;
      }

      let isDecimalAvailable =
        config.isDecimalAllowed &&
        event.target.id &&
        this.decimalKeyPressedIds.find((x) => x == event.target.id);
      let value = parseFloat(
        currentValue + (isDecimalAvailable ? '.' : '') + event.key,
      );
      if (value > config.maxValue) return false;
    }

    if (
      config.maxDigits != null &&
      config.navigateToNextIdIfMaxDigitReached != ''
    ) {
      setTimeout(() => {
        if (
          event.target.value &&
          event.target.value.toString().length == config.maxDigits
        ) {
          let element = document.getElementById(
            config.navigateToNextIdIfMaxDigitReached,
          ) as HTMLInputElement;
          if (element) {
            element.focus();
          }
        }
      }, 10);
    }

    if (
      config.maxDigits != null &&
      event.target.value &&
      event.target.value.toString().length == config.maxDigits
    ) {
      return false;
    }
    return true;
  }

  onNumEnter(num: any, digits: string) {
    return num == null || num.toString().length < parseInt(digits);
  }

  onNumEnterEvent(event: any, digits: number) {
    if (this.esacpeKeys.indexOf(event.key) > -1) return true;
    if (!(this.intValues.indexOf(event.key) > -1)) return false;
    let num = event.target.value;
    let strNum = num == null ? '' : num.toString();
    if (strNum != '' && !this.validation.isNumber(strNum)) return false;
    return num == null || strNum.length < digits;
  }

  public decimalValues = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
  ];
  public intValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  public esacpeKeys = [
    'Backspace',
    'ArrowLeft',
    'ArrowRight',
    'Shift',
    'Home',
    'End',
    'Delete',
  ];
  validation = {
    isEmailAddress: function (str) {
      var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return pattern.test(str); // returns a boolean
    },
    isNotEmpty: function (str) {
      var pattern = /\S+/;
      return pattern.test(str); // returns a boolean
    },
    isNumber: function (str) {
      var pattern = /^\d+$/;
      return pattern.test(str); // returns a boolean
    },
    isSame: function (str1, str2) {
      return str1 === str2;
    },
  };

  public handleTabForTextArea(event: any) {
    if (event.key == 'Tab') {
      event.preventDefault();
      var start = event.target.selectionStart;
      var end = event.target.selectionEnd;
      event.target.value =
        event.target.value.substring(0, start) +
        '\t' +
        event.target.value.substring(end);
      event.target.selectionStart = event.target.selectionEnd = start + 1;
    }
  }

  encryptCrypto(text: string, ky?: string): string {
    ky = ky ? ky : this.reques;
    return ky ? CryptoJS.AES.encrypt(text, ky).toString() : undefined;
  }

  decryptCrypto(text: string, ky?: string): string {
    return CryptoJS.AES.decrypt(text, ky ? ky : this.reques).toString(
      CryptoJS.enc.Utf8,
    );
  }

  getRandomString(length, isNumberOnly = false): string {
    var randomChars = isNumberOnly
      ? '123456789'
      : 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(
        Math.floor(Math.random() * randomChars.length),
      );
    }
    return result;
  }

  isOnlyEnglishLanguage(value: string): boolean {
    value = value.replace(/[\t\n ./<>?;:"'`!@#$%^&*()\[\]{}_+=|\\-]/g, '');
    value = value.replace(/[a-zA-Z0-9]/g, '');
    return value.length == 0;
  }

  getTodayDateForCalender(): string {
    let now = this.getDeviceDate();
    let day = now.getDate();
    let month = now.getMonth() + 1;
    return (
      (day.toString().length == 1 ? '0' : '') +
      day +
      '-' +
      (month.toString().length == 1 ? '0' : '') +
      month +
      '-' +
      now.getFullYear()
    );
  }

  Sort(
    items: any,
    isAscending: boolean = true,
    fieldName?: string,
    isFilterByNumber?: boolean,
  ): any {
    if (isFilterByNumber) {
      if (isAscending) {
        if (fieldName) {
          return items.sort((a, b) =>
            parseFloat(a[fieldName]) < parseFloat(b[fieldName]) ? -1 : 1,
          );
        } else {
          return items.sort((a, b) => (parseFloat(a) < parseFloat(b) ? -1 : 1));
        }
      } else {
        if (fieldName) {
          return items.sort((a, b) =>
            parseFloat(a[fieldName]) > parseFloat(b[fieldName]) ? -1 : 1,
          );
        } else {
          return items.sort((a, b) => (parseFloat(a) > parseFloat(b) ? -1 : 1));
        }
      }
    } else {
      if (isAscending) {
        if (fieldName) {
          return items.sort((a, b) => (a[fieldName] < b[fieldName] ? -1 : 1));
        } else {
          return items.sort((a, b) => (a < b ? -1 : 1));
        }
      } else {
        if (fieldName) {
          return items.sort((a, b) => (a[fieldName] > b[fieldName] ? -1 : 1));
        } else {
          return items.sort((a, b) => (a > b ? -1 : 1));
        }
      }
    }
  }
}

export enum LocalCacheKey {
  CollapsedTreeKeys = 'collapsed_tree',
  LastCamera = 'last_camera',
  DeviceId = 'device_id',
}

export const GetLocalCacheCollapsedTreeKeys = (
  cacheSuffix?: string,
): string[] => {
  const values = GetLocalCache(LocalCacheKey.CollapsedTreeKeys, cacheSuffix);
  return values ? (JSON.parse(values) as string[]) : ([] as string[]);
};

export const GetLocalCache = (
  localCacheKey: LocalCacheKey,
  cacheSuffix?: string,
): string | undefined => {
  return (
    localStorage.getItem(
      localCacheKey + (cacheSuffix ? '_' + cacheSuffix : ''),
    ) ?? undefined
  );
};

export const SetLocalCache = (
  localCacheKey: LocalCacheKey,
  value: string,
  cacheSuffix?: string,
): void => {
  localStorage.setItem(
    localCacheKey + (cacheSuffix ? '_' + cacheSuffix : ''),
    value,
  );
};

export enum TriggeredEvent {
  Close = 0,
  Ok = 1,
  Switched = 2,
  Scanned = 3,
}

export enum ItemsDisplayType {
  ProductsForOneBusiness = 1,
  OnlyBusiness = 2,
  ProductsForMultiBusinesses = 3,
}

export enum AccessRange {
  None = 0,
  Global = 1,
  Country = 2,
  State = 3,
  District = 4,
  Constituency = 5,
}

export enum SummaryType {
  None = 0,
  User = 1,
  Business = 2,
  Product = 3,
  ServiceProvider = 4,
  Receipt = 5,
  Guide = 6,
}

export enum CreditType {
  None = 0,
  Billing = 1,
  Manual = 2,
}

export enum SeatType {
  None = 0,
  Line = 1,
  Round = 2,
  Rectangle = 3,
  Square = 4,
  Custom = 5,
  Cylinder = 6,
}

export enum Status {
  None = 0,
  Success,
  Failed,
  Duplicate,
  WaitingForApproval,
  Invalid,
  NotAllowed,
  DataRequired,
  UnAvailable,
  RangeNotAllowed,
  NeedOtpVerification,
  UnKnown,
  InUse,
  ErrorOccured,
  InActive,
  Blocked,
  New,
  Updated,
  Running,
  LimitExceeded,
  EmailRequired,
  NoChange,
  SerialNumberRequired,
  InventoryRequired,
  NeedBRN,
  NeedConfirmation,
  SuccessWithMoreAction,
  ResetPwd,
  MinimumRequired,
  Custom,
  NoLimit,
  NotFound,
  NeedPrimarySelection,
  QrPaymentGenerated,
  Allowed,
}

export interface PrintHtml {
  html: string;
  values?: string[];
  isSinglePrint: boolean;
}

export interface StatusWithId {
  status: Status;
  id: string;
  value?: string;
  values?: string[];
}

export enum CommunicationTemplate {
  None = 0,
  ResetPasswordOtp = 1,
  BusinessVerificationOtp = 2,
  TokenGenerated = 3,
  TokenAccepted = 4,
  TokenRejected = 5,
  TokenPaid = 6,
  TokenOutForDelivery = 7,
  TokenReady = 8,
  TokenDelivered = 9,
  MemberRegistered = 10,
  AccessGranted = 11,
  AccessRemoved = 12,
  NumberAddedToWhiteList = 13,
  WhiteListNumberRequested = 14,
  WhiteListNumberNeedAction = 15,
  AppointmentBookedByCustomer = 16,
  AppointmentBookedByBusiness = 17,
  AppointmentAcceptedByCustomer = 18,
  AppointmentAcceptedByBusiness = 19,
  CompanyInvoiceGenerated = 20,
  OtpToDeductFromCustomerPnixSoftWallet = 21,
  TokenAssigned = 22,
  SeatAllocated = 23,
  AppointmentCancelled = 24,
  AppointmentUpdated = 25,
  EmailVerificationOtp = 26,
  ServiceDownAlert = 27,
  ReceiptAllocated = 28,
  InvoiceGenerated = 29,
  OtpForBusinessDeactivate = 30,
  OtpToDeleteBills = 31,
  OtpForBusinessPayment = 32,
  RefundCompleted = 33,
  SendBillToPhone = 34,
  PeriodicalReport = 35,
  PlanExpiryReminder = 36,
  PendingTasks = 37,
  TaskAssigned = 38,
}

export interface PlanPurchaseInvoiceInitialization {
  planPurchaseInvoiceStatuses: KeyValueSet[];
  deductionMethods: KeyValueSet[];
  content: Wrappers10;
}

export interface PlanPurchaseInvoiceDetailInitialization {
  planTypes: KeyValueSet[];
  monthlyPlans: KeyValueSet[];
  deductionMethods: KeyValueSet[];
  pricing: ToolPricing[];
  basicPlanMonths: KeyValueSet[];
  planPurchaseInvoiceStatus: PlanPurchaseInvoiceStatus;
  content: Wrappers20;
  businessId: string;
  planInteractionType: InteractionType;
  decuctedMethod: DeductionMethod;
}

export interface Wrappers20 {
  items: KeyValues20[];
  paging: Paging;
  lessStockCount?: number;
  content?: KeyValues10;
  configValues?: KeyValueSet[];
  productCategories?: KeyValues3[];
  businessTaxesFull?: KeyValues5Sets[];
}

export interface ToolPricing {
  type: ToolPricingType;
  price: number;
}

export interface LeftRightWrapper {
  source: KeyValueSet[];
  selected: string[];
}

export interface Pricing {
  chargeMethod: ChargeMethod;
  chargeForType: NotificationType | ToolPricingType;
  amount: number;
}

export enum ReceiptType {
  None = 0,
  Cus_General = 1,
  Cus_45mm = 2,
  Cus_50mm = 3,
  Cus_60mm = 4,
  Cus_70mm = 5,
  Cus_80mm = 6,
  Cus_90mm = 7,
  Cus_A4 = 8,
  Fix_Square_1_General = 9, //For common template
  Fix_Square_1_A4 = 10,
  Fix_Square_1_A5 = 11,
  Fix_CustomLabel_1_General = 12, //For common template
  Fix_CustomLabel_1_A4 = 13,
  Fix_CustomLabel_1_A5 = 14,
  Fix_Direct_Tally_1_A4_Gen = 15,
  Fix_Direct_Half_A4_1_Gen = 16,
  Fix_Direct_Truck_Simple_1_XXmm = 17,
  Fix_Direct_Truck_Simple_1_45mm_XX = 18,
  Fix_Direct_Truck_Simple_1_50mm_XX = 19,
  Fix_Direct_Truck_Simple_1_60mm_XX = 20,
  Fix_Direct_Truck_Simple_1_70mm_XX = 21,
  Fix_Direct_Truck_Simple_1_80mm_XX = 22,
  Fix_Direct_Truck_Simple_1_90mm_XX = 23,
  Fix_Direct_Truck_Simple_2_XXmm = 24,
  Fix_Direct_Truck_Simple_2_45mm_XX = 25,
  Fix_Direct_Truck_Simple_2_50mm_XX = 26,
  Fix_Direct_Truck_Simple_2_60mm_XX = 27,
  Fix_Direct_Truck_Simple_2_70mm_XX = 28,
  Fix_Direct_Truck_Simple_2_80mm_XX = 29,
  Fix_Direct_Truck_Simple_2_90mm_XX = 30,
  Fix_Direct_Truck_Simple_3_XXmm = 31,
  Fix_Direct_Truck_Simple_3_45mm_XX = 32,
  Fix_Direct_Truck_Simple_3_50mm_XX = 33,
  Fix_Direct_Truck_Simple_3_60mm_XX = 34,
  Fix_Direct_Truck_Simple_3_70mm_XX = 35,
  Fix_Direct_Truck_Simple_3_80mm_XX = 36,
  Fix_Direct_Truck_Simple_3_90mm_XX = 37,
  Cus_40mm = 38,
  Cus_35mm = 39,
  Cus_30mm = 40,
  Cus_25mm = 41,
  Cus_20mm = 42,
  Fix_Direct_Tailoring_Shirt_Gen = 43,
  Fix_Direct_Tailoring_Trouser_Gen = 44,
  Fix_Direct_Tailoring_Suit_Gen = 45,
  Fix_Direct_VisitorPass_Gen = 46,
  Fix_Direct_A5_Tax_Gen = 47,
}

export interface SerialNumberInitialization {
  statuses: KeyValueSet[];
  items: Wrappers10;
}

export interface Wrapper10 {
  content: KeyValues10;
  languageContents: any;
  range: KeyValues10;
  timeZones: number[];
}

export interface Wrapper15 {
  content: KeyValues15;
  languageContents: any;
  range: KeyValues10;
  timeZones: number[];
}

export interface MessageSettingsWrapper {
  content: KeyValues5;
  selectedForCustomer: number[];
  selectedForBusiness: number[];
  options: KeyValueSet[];
  notificationTypes: KeyValueSet[];
  similarSettings: KeyValues5[];
}

export enum ActiveInactiveFor {
  None = 0,
  Language,
  LanguageSection,
  Menu,
  Country,
  Location,
  Configuration,
  GlobalConfig,
  Field,
  Relationship,
  Access,
  Business,
  Product,
  BlockBusiness,
  Seat,
  SeatDelete,
  GetStarted,
  Tips,
  TipsFlash,
  StockManagment,
  ImageUpload,
  Gallery,
  Supplier,
  PurchaseEntry,
  PurchaseEntryDetail,
  Lookup,
  PrinterTemplate,
  PrinterDevice,
  PrinterTemplateMap,
  PrinterDeviceMap,
  PrinterSetupOnOff,
  PrinterSetup,
  BillingAdjustmentFormula,
  BatchEntry,
  BatchEntryDetail,
  ProductBatchInventory,
  QrPaymentConfig,
  CustomLabelPrint,
  CustomLabelPrintPosition,
  ReceiptIcon,
  ArchiveBusiness,
  ArchiveUser,
  QrPaymentConfigPrimary,
  QrVariable,
  QrGeneratorUpload,
  CustomField,
  CustomField_IsProductsGrid,
  CustomField_IsProductSearch,
  CustomField_IsProductNameInReceipt,
  RawInventoryForProduct,
  DeleteRawInventoryForProduct,
}

export enum PageKeyAccessType {
  None = 0,
  Page = 1,
  Role = 2,
  Actions = 3,
}

export enum FocusInputType {
  TextBox = 1,
  NgxDropDown = 2,
  CheckBox = 3,
  RadioButton = 4,
  Button = 5,
  Calendar = 6,
}

export enum BusinessType {
  None = 0,
  EndCustomer = 1,
  Retailers = 2,
  WholeSellerOrDistributers = 3,
  Agent = 4,
  ManufacturerOrIndustry = 5,
}

export enum OtpStatus {
  None = 0,
  Verified,
  Failed,
  TryAfter24Hrs,
  TryAfter1Hr,
  InvalidValue,
  ChangePassword,
  DataRequired,
}

export enum OtpType {
  None = 0,
  MobileVerification = 1,
  DataVerification = 2,
  NewAccount = 3,
  ForgotPassword = 4,
  RelationshipVerification = 5,
  NewAccountWithRelationShip = 6,
  EditAccount = 7,
  PnixSoftWalletUser = 8,
  PnixSoftWalletBusiness = 9,
  UpdateUserEmail = 10,
  BusinessSetup = 11,
  DeactivateBusiness = 12,
  DeleteBills = 13,
  VerifyEmail = 14,
  RefundOtp = 15,
  OpenAuthConfig = 16,
  EnableFileDeletion = 17,
  CleanBusinessData = 18,
  MarkAsPaidForAcceptedToken = 19,
}

export enum RelationShipRole {
  None = 0,
  Admin = 1,
  Employee = 2,
  EndCustomer = 3,
  Business = 4,
  Deliverer = 5,
}

export enum NotificationType {
  None = 0,
  SMS = 1,
  Email = 2,
  Push = 3,
  WhatsApp = 4,
}

export enum GeneralConfigType {
  None = 0,
  BusinessType = 1,
  ReceiptType = 2,
  NotificationType = 3,
  DeliveryType = 4,
  MeasurementType = 5,
  SearchRange = 6,
  SearchWith = 7,
  Fields = 8,
  CommunicationTemplatePush = 9,
  PaymentType = 10,
  ProductRemoveReason = 11,
  RelationShipRole = 12,
  CreditType = 13,
  PagingLanguageSection = 14,
  //PageAction = 15,
  PagingMenus = 16,
  PagingMembers = 17,
  PagingRequests = 18,
  RequestStatus = 19,
  RequestType = 20,
  PagingSellers = 21,
  PagingGeneralConfig = 22,
  PagingPayments = 23,
  PagingDeliverer = 24,
  PagingSearch = 25,
  CompanyInvoiceLabelConfiguration = 26,
  Months = 27,
  RentReceiptType = 28,
  RentReceiptItemType = 29,
  AccessRange = 30,
  AccessRole = 31,
  PagingGallery = 32,
  PagingAppoinments = 33,
  BillingMode = 34,
  StartUpType = 35,
  BillingStatus = 36,
  ReturnReason = 37,
  SerialNumberStatus = 38,
  PagingBills = 39,
  CommunicationTemplateSms = 40,
  CommunicationTemplateEmail = 41,
  WhiteListStatus = 42,
  ProductColumnKey = 43,
  ProductLogStatus = 44,
  ProductLogReason = 45,
  PagingSalesReport = 46,
  CommunicationTemplateNameBusiness = 47,
  CommunicationTemplateNameServiceProvider = 48,
  PagingMessageLogs = 49,
  ChargeMethod = 50,
  ToolPricingType = 51,
  PagingComplaints = 52,
  ComplaintStatus = 53,
  PrepaidDetailReason = 54,
  PagingPrepaidDetail = 55,
  PaidType = 56,
  PaymentGatewayStatus = 57,
  PagingPaymentGateway = 58,
  PagingPaidByCompanyDetail = 59,
  SeatType = 60,
  PagingProducts = 61,
  PagingSessions = 62,
  PagingGetStarted = 63,
  PagingTips = 64,
  ReferenceReason = 65,
  PagingReference = 66,
  PagingLogs = 67,
  PagingNotifications = 68,
  CommunicationTemplateEmailSubject = 69,
  PagingLiveTokens = 70,
  AdditionalServiceType = 71,
  AdditionalServiceStatus = 72,
  CountryLocationLevel = 73,
  PagingRentReceiptLogs = 74,
  ProductSerialNumberType = 75,
  PagingSerialNumbers = 76,
  PagingRelationship = 77,
  BulkColumnKey = 78,
  BulkLogStatus = 79,
  BulkLogReason = 80,
  GalleryType = 81,
  ReceiptOption = 82,
  ReceiptOption_Header = 83,
  ReceiptOption_Sample = 84,
  ReceiptOption_FixedValue = 85,
  BusinessEnabledOption = 86,
  PagingExploreItems = 87,
  PagingSuppliers = 88,
  PagingPurchaseEntries = 89,
  PagingPurchaseEntryDetails = 90,
  LookupType = 91,
  PagingLookup = 92,
  PrinterTab = 93,
  SalesReportBy = 94,
  PlanPurchaseInvoiceStatus = 95,
  DeductionMethod = 96,
  PlanType = 97,
  PagingPlanPurchaseInvoice = 98,
  BasicPlanMonths = 99,
  InvoiceTemplateName = 100,
  CommunicationTemplate_WhatsApp = 101,
  PagingBatchEntries = 102,
  PagingBatchEntryDetails = 103,
  QrPaymentStatus = 104,
  SupportingType = 105,
  PagingQrPaymentLog = 106,
  CurrencySymbol = 107,
  PaymentGatewayServiceType = 108,
  QrLabelTemplateType = 109,
  QrLabelVariableType = 110,
  QrLabelDynamicValue = 111,
  PagingQrGeneratorUpload = 112,
  PurchaseEntryType = 113,
  CustomFieldDisplay = 114,
  MeasurementType_Short = 115,
  PurchaseEntryStatus = 116,
  UpdatePurchaseEntryDetailFor = 117,
  PagingSaleSettlement = 118,
  ProductEntryType = 119,
  AuthConfigType = 120,
  PagingB2bAccounts = 121,
  PagingInvoices = 122,
}

export enum AuthConfigType {
  None = 0,
  BunnyStorage = 1,
}

export enum ProductEntryType {
  None = 0,
  Billing = 1,
  PurchaseEntryOnly = 2,
}

export enum QrLabelTemplateType {
  None = 0,
  Product = 1,
  ProductSerialNumber = 2,
  Business = 3,
  CustomLabel = 4,
}

export enum QrLabelVariableType {
  None = 0,
  QrCode = 1,
  BarCode = 2,
  FixedLabel = 3,
  DynamicValue = 4,
  CurrencySymbol = 5,
}

export enum BillingStatus {
  None = 0,
  Draft = 1,
  Submitted = 2,
  Accepted = 3,
  Rejected = 4,
  InProgress = 5,
  Cancelled = 6,
  Ready = 7,
  OutForDeliver = 8,
  Delivered = 9,
  Returned = 10,
  New = 11,
  AmountPaid = 12,
  AmountNotPaid = 13,
  ReAccepted = 14,
}

export enum DeliveryType {
  None = 0,
  Self = 1,
  Door = 2,
  Dining = 3,
  TakeAway = 4,
  Appointment = 5,
  DeliveryChallan = 6,
  Quotation = 7,
}

export enum GraphType {
  None = 0,
  Bar = 1,
  Line = 2,
  Pie = 3,
}

export enum RequestType {
  None = 0,
  CreateTestUsers = 1,
  CreateTestBusinesses = 2,
  CreateTestProducts = 3,
  CreateTestDeliverer = 4,
  BulkUploadProducts = 5,
  BulkUploadLocations = 6,
  BulkUploadSerialNumbers = 7,
  BulkUploadUsers = 8,
}

export enum WorkingRangeType {
  None = 0,
  Deliverer = 1,
  Business = 2,
  Appoinment = 3,
  PickUp = 4,
}

export enum AppointmentType {
  None = 0,
  Business = 1,
  ServiceProvider = 2,
  Receipt = 3,
}

export enum InteractionType {
  None = 0,
  User = 1,
  Business = 2,
  ServiceProvider = 3,
  Bill_PnixSoft = 4,
  B2B = 5,
  Auditor = 6,
}

export interface ExcelSalesReport {
  PaidOn: string;
  TokenNumber: string;
  TotalWithoutTax: number;
  TotalWithTax: number;
  Adjustment: number;
  ManualDiscount: number;
  GrandTotal: number;
}

export interface ExcelSalesReportWithProfit extends ExcelSalesReport {
  PurchasedAmount: number;
  Profit: number;
}

export interface ExcelSalesReportTitle {
  Title: string;
  Quantity: number;
  TotalWithoutTax: number;
  TotalWithTax: number;
}

export interface ExcelSalesReportTitleWithProfit extends ExcelSalesReportTitle {
  PurchasedAmount: number;
  Profit: number;
}

export interface ExcelSalesReportTitleDetail {
  Title: string;
  Quantity: number;
  TotalWithoutTax: number;
  TotalWithTax: number;
  TokenNumber: string;
  PaidOn: string;
}

export interface ExcelSalesReportTitleDetailWithProfit extends ExcelSalesReportTitleDetail {
  PurchasedAmount: number;
  Profit: number;
}

export enum PlanPurchaseInvoiceStatus {
  None = 0,
  Draft = 1,
  Cancelled = 2,
  ToBuy = 3,
  Generated = 4,
  Refunded = 5,
  Activated = 6,
}

export enum DeductionMethod {
  None = 0,
  Wallet = 1,
  Cash = 2,
  Online = 3,
  Waiver = 4,
}

export enum PrepaidDetailReason {
  None = 0,
  Recharged = 1,
  DedcutedForMonthlyBill = 2,
  DeductedForNotificationAlert = 3,
  DedcutedForReceipt = 4,
  Refund = 5,
}

export enum PagingSearch {
  None = 0,
  ProductName = 1,
  BusinessName = 2,
}

export interface StatusWithId {
  id: string;
  status: Status;
  value?: string;
}

export interface KeyValueIdForPaymentMode {
  k: number;
  v: number;
}

export interface LatePayment {
  src?: string;
  paidOn: Date;
  paidMode: number;
  paidAmount: number;
}

export interface KeyValueIdForPaymentModeWrapper {
  items: KeyValueIdForPaymentMode[];
  latePayments: LatePayment[];
}

export interface FileDownload {
  content: any;
  fileName: string;
}

export interface OtpStatusWithId {
  status: OtpStatus;
  id: string;
}

export interface Paging {
  totalCount: number;
  currentPage: number;
  totalPage: number;
  dataPerPage: number;
  isReverseOrder: boolean;
  searchKey: string;
  searchType: number;
  searchTypes: KeyValueSetInt[];
  dateFromS: string;
  dateToS: string;
  pageType: number;
  isAutoRefresh: boolean;
  data: KeyValues5;
  //dateFrom: string;
  //dateTo: string;
  sumVal?: number;
  sumVals?: number[];
}

export enum SalesReportBy {
  None = 0,
  Receipt = 1,
  Product = 2,
  HsnCode = 3,
  SacCode = 4,
  ProductCategory = 5,
}

export interface KeyValueSetInt {
  key: number;
  value: string;
  isSelected: boolean;
}

export interface AdditionalDetailsWrapper {
  details: KeyValues3;
  newAddress: KeyValues3;
  deliveryAddress: KeyValues5[];
  isEmailConfirmed?: boolean;
}

export interface DisplaySection {
  content: KeyValueSet[];
  languages: KeyValues3[];
}

export interface AccessInitialization {
  accessTypes: KeyValueSet[];
  accessRanges: KeyValueSet[];
  content: KeyValues10[];
}

export interface KeyValueSet {
  key: string;
  value: string;
  isSelected?: boolean;
  s_value?: string;
  isInActive?: boolean;
  isMerge?: boolean;
  mergeOrder?: string;
  values?: string[];
  selectedValueKey?: string;
}

export enum TaskStatus {
  None = 0,
  Defined = 1,
  InProgress = 2,
  Completed = 3,
  Aborted = 4,
  Blocked = 5,
}

export enum TaskUpdateType {
  None = 0,
  Primary = 1,
  AddBlock = 2,
  Comment = 3,
}

export interface KeyValues3 {
  isSelected?: boolean;
  isReadonly?: boolean;
  key: string;
  v1: string;
  v2: string;
  v3: string;
}

export interface SeatsInitialization {
  isEnabled: boolean;
  sessionKey: string;
  groups: KeyValues3[];
  availablity: KeyValueSets[];
  tableBills: KeyValues[];
}

export interface ActiveSessions {
  sessions: KeyValues10[];
  seats: SeatsInitialization[];
  bills: KeyValueSets[];
}

export interface ActiveSession {
  seat: KeyValues3;
  session: KeyValues10;
  seats: SeatsInitialization;
  bill: KeyValueSets;
}

export interface Wrappers5 {
  total: number;
  content?: KeyValues5;
  settings?: KeyValues5;
  items: KeyValues5[];
  paging: Paging;
}

export interface Wrappers5WithStatus {
  status: Status;
  businesses: KeyValues15[];
  allowedMenus?: MenuWrapper[];
  deviceSettings?: DeviceInfoSetting[];
  wrapper: Wrappers5;
  receiptTemplates?: ReceiptTemplateRes[];
  printerNamesWithReceiptTemplates?: PrinterNamesWithReceiptTemplatesRes[];
  weightMachines?: LocalWeightMachineName[];
}

export interface Wrappers10 {
  isEnabled: boolean;
  total: number;
  content?: KeyValues10;
  settings?: KeyValues10;
  items: KeyValues10[];
  paging: Paging;
}

export interface Wrappers15 {
  lessStockCount?: number;
  items: KeyValues15[];
  content?: KeyValues10;
  paging: Paging;
  configValues?: KeyValueSet[];
  productCategories?: KeyValues3[];
  businessTaxesFull?: KeyValues5Sets[];
}

export interface KeyValues10Date {
  content: KeyValues10;
  date: KeyValues10;
}

export interface KeyValueSets {
  key: string;
  s_value?: string;
  type?: number;
  isSelected?: boolean;
  selectedValueKey?: string;
  value: KeyValueSet[];
}

export interface KeyValueId {
  isSelected?: boolean;
  key: string;
  value: string | number;
  s_value?: string;
  searchText?: string;
}

export interface HtmlStyle {
  type: HtmlStyleType;
  align: HtmlStyleAlignment;
  border: HtmlBorderLine;
  marginTop?: number;
  lineHeight?: number;
  width?: number;
  fontSize?: number;
  isBold?: boolean;
  content: string;
  isActive: boolean;
}

export enum HtmlStyleType {
  ReceiptTop = 1,
  ReceiptBottom = 2
}

export enum HtmlStyleAlignment {
  Left = 1,
  Right = 2,
  Center = 3
}

export enum HtmlBorderLine {
  None = 1,
  All = 2,
  Top = 3,
  Bottom = 4,
}

export interface KeyValues {
  key: string;
  values: string[];
}

export interface KeyValues5 {
  isSelected: boolean;
  isReadonly?: boolean;
  value?: number;
  key: string;
  v1: string;
  v2: string;
  v3: string | number | any;
  v4: string | number | any;
  v5: string;
}

export interface ReceiptTemplateRes {
  id: string;
  businessId: string;
  title: string;
  receiptType: ReceiptType;
  isCustomerCopy?: boolean;
  options: ReceiptOption[];
  businessTypes?: BusinessType[];
}

export interface PrinterNamesWithReceiptTemplatesRes {
  id: string;
  businessId: string;
  printerName: string;
  networkName: string;
  networkUrl: string;
  temporaryFolderPath?: string;
  receiptTemplateIds: string[];
}

export interface DeviceInfoSetting {
  Id: string,
  BusinessId: string,
  Title: string,
  STitle: string,
  DeviceOs: number | string,
  BillingMode: number | string,
  DeviceCount: number,
  PageKeys?: number[],
  IsEnableSilentPrint?: boolean,
  IsEnableWeightMachine?: boolean,
  DirectPrintUrl?: string,
  DirectWeightMachineUrl?: string,
  LocalNetworkSettingIdsForPrint?: string[],
  LocalNetworkSettingIdForWeight?: string,
  IsCompactViewInBillingMode?: boolean,
  IsCompactViewInSalesReport?: boolean,
  NetworkWeightMachineNameId?: string,
  QrLabelPrinterNameId?: string,
  IsActive: boolean,
  CreatedBy: string,
  CreatedOn: Date,
  UpdatedBy: string,
  UpdatedOn: Date
}

export interface CustomLabelInitialization {
  contents: Wrappers5[];
  replaceLabels: KeyValueId[];
  customLabelInputTypes: KeyValueSet[];
}

export interface ProductPrice {
  minQty?: number;
  price: number;
  batchId?: string;
  batchTitle?: string;
  availableQty?: number;
  businessTaxesFull?: KeyValues5Sets[];
  productTaxes?: PricingManagementWrapper[];
  taxCategoryId?: string;
  productId: string;
}

export interface KeyValues10 {
  isReadonly?: boolean;
  value?: number | null;
  key: string;
  v1: any;
  v2: string;
  v3: string | number | any;
  v4: any;
  v5: any;
  v6: string;
  v7: string;
  v8: string | number | any;
  v9: string;
  v10: string;
  isSelected: boolean;
  values: string[];
}

export enum CustomFieldDisplay {
  None = 0,
  ProductsGrid = 1,
  ProductSearch = 2,
  ProductNameInReceipt = 3,
}

export interface BilledProduct {
  productId: string;
  details: KeyValues30;
  taxes?: KeyValueId[];
  taxesFull?: PricingManagementWrapper;
}

export interface KeyBoolean {
  key: number;
  isSelected?: boolean;
  isDisabled?: boolean;
  isInVisible?: boolean;
  text?: string;
  searchKey?: string;
}

export interface KeyValues15 {
  isReadonly?: boolean;
  isSelected: boolean;
  value?: number | null;
  key: string;
  v1: any;
  v2: string;
  v3: string;
  v4: any;
  v5: any;
  v6: string;
  v7: string;
  v8: string;
  v9: string | number | any;
  v10: string | number | any;
  v11: string | number | any;
  v12: string;
  v13: string;
  v14: string;
  v15: string;
  values?: string[];
  customFields?: KeyValueId[];
  productTax?: PricingManagementWrapper;
}

export interface CartSession {
  Id: string;
  BusinessId: string | any;
  UserId: string | any;
  ProductIdQuantity: KeyValueId[];
}

export interface KeyValues20 {
  isSelected?: boolean;
  key?: string;
  v1?: string | any;
  v2?: string;
  v3?: string;
  v4?: string | any;
  v5?: string | any;
  v6?: string;
  v7?: string;
  v8?: string;
  v9?: string;
  v10?: string | any;
  v11?: string | any;
  v12?: string;
  v13?: string;
  v14?: string;
  v15?: string;
  v16?: string;
  v17?: string;
  v18?: string;
  v19?: string;
  v20?: string;
  values?: string[];
  customFields?: KeyValueId[];
  productTax?: PricingManagementWrapper;
}

export interface KeyValues30 {
  isSelected?: boolean;
  key?: string;
  v1?: string | any;
  v2?: string;
  v3?: string;
  v4?: string | any;
  v5?: string;
  v6?: string;
  v7?: string;
  v8?: string;
  v9?: string;
  v10?: string;
  v11?: string;
  v12?: string;
  v13?: string;
  v14?: string;
  v15?: string;
  v16?: string;
  v17?: string;
  v18?: string;
  v19?: string;
  v20?: string;
  v21?: string;
  v22?: string;
  v23?: string;
  v24?: string;
  v25?: string | any;
  v26?: string;
  v27?: string;
  v28?: string;
  v29?: string;
  v30?: string;
  values?: string[];
  customFields?: KeyValueId[];
  images?: string[];
}

export interface UserInfo {
  basic: KeyValues20;
  systemInfo: KeyValues10;
  roles: string[];
  billingMode: KeyValueSet[];
}

export interface Languages {
  val: KeyValues3[];
  valEqu: KeyValues3[];
  languageContentsJson: DisplaySection;
  styles: string;
}

export interface Wrappers3 {
  items: KeyValues3[];
  paging: Paging;
}

export interface Wrapper3 {
  content: KeyValues3;
  languageContents: any;
}

export interface Wrapper5 {
  content: KeyValues5;
  languageContents: any;
  range: KeyValues10;
}

export interface Payment {
  paymentId: string;
  amount: number;
  currrency: string;
  interactionType: InteractionType;
  notes?: string;
  orderId: string;
  businessOrUserId: string;
  emailId?: string;
  serviceType: PaymentGatewayServiceType;
  paidType: PaidType;
  ids?: string[];
  datas?: KeyValues5[];
  supportingId?: string;
  isPaymentLink?: boolean;
}

export interface DelivererWrapper {
  source: Wrapper10;
  myBusiness: KeyValues3[];
  languageAddress: any;
  notificationTypes: string[];
}

export interface MemberWrapper {
  content: KeyValues10;
  localLocations: any;
  languageNames: any;
  languageNamesShort: any;
}

export interface LessAlert {
  lessStockBusiness: KeyValueInt[];
  messageCredits: KeyValuesGroup3[];
  notificationTypes: KeyValueSet[];
}

export interface KeyValuesGroup3 {
  key: KeyValues3;
  values: KeyValues3[];
}

export interface LastPagingSetup {
  userId: string;
  pageType: number;
  paging: Paging;
  additionalFilter: any;
}

export interface LoggedMemberWrapper {
  loggedMember: MemberWrapper;
  ctry: string;
  memberStatus: Status;
  pwdStatus: Status;
  allowedMenus: MenuWrapper[];
  businesses: KeyValues15[];
  brnIds: string[];
  used: LastUsedKey[];
  deviceSettings?: DeviceInfoSetting[];
  receiptTemplates?: ReceiptTemplateRes[];
  printerNamesWithReceiptTemplates?: PrinterNamesWithReceiptTemplatesRes[];
  weightMachines?: LocalWeightMachineName[];
}

export interface Header {
  globalLanguages: KeyValues3[];
  equivalent: KeyValues3[];
  allowedMenus: Menus[];
}

export interface MenuWrapper {
  businessId?: string;
  menus: Menus[];
  equivalent: KeyValues3[];
}

export interface Menus {
  menu: KeyValues10;
  subMenus: Menus[];
}

export interface Wrappers3WithStatus {
  status: Status;
  contents: KeyValues5[];
  businesses: KeyValues10[];
}

export interface BusinessWrapper {
  content: KeyValues30;
  supportings: any;
  taxes: KeyValues5Sets[];
  taxesFull: KeyValues5Sets[];
  expectedBusinessTypes: [];
  deliveryTypes: [];
  contactNumbers: [];
  businessEnabledOptions: KeyBoolean[];
  emails: [];
  notificationTypes: string[];
  languageContentsName: any;
  languageContentsAddress: any;
  languageContentsDescription: any;
  localLocations: any;
  taxCategories: KeyValues5[];
  productLabels: KeyValueSet[];
}

export interface KeyValues5Sets {
  key: string;
  values: KeyValues5[];
}

export interface SellerInitialization {
  business: BusinessWrapper;
  currencySymbols: KeyValueSet[];
  businessTypes: KeyValueSet[];
  receiptTypes: KeyValueSet[];
  notificationTypes: KeyValueSet[];
  deliveryTypes: KeyValueSet[];
  supporting: any;
  taxes: KeyValues5Sets[];
}

export interface SupplierWrapper {
  businessId: string;
  content: KeyValues15;
  supportings: any;
  contactNumbers: string[];
  emails: string[];
  languageContentsName: any;
  languageContentsAddress: any;
  languageContentsDescription: any;
}

export interface SupplierInitialization {
  supplier: SupplierWrapper;
  supporting: any;
}

export interface PurchaseEntryInitialization {
  purchaseEntry: KeyValues15;
  suppliers: KeyValues5[];
}

export interface PurchaseEntryDetailsInitialization {
  purchaseEntry: KeyValues15;
  source: Wrappers20;
  isMaintainStatus: boolean;
  purchaseEntryStatuses: KeyValueSet[];
  upadatePurchaseEntryDetailFors: KeyValueSet[];
}

export interface BatchEntryInitialization {
  batchEntry: KeyValues15;
}

export interface BatchEntryDetailsInitialization {
  batchEntry: KeyValues15;
  source: Wrappers15;
}

export interface StatusKeyValues15 {
  statusWithId: StatusWithId;
  content?: KeyValues15;
}

export interface StatusKeyValues20 {
  statusWithId: StatusWithId;
  content?: KeyValues20;
}

export interface DelivererInitialization {
  myDeliverer: KeyValues5;
  source: Wrapper10Initialization;
}

export interface SerialNumberMapInitialization {
  availableSerialNumbers: KeyValues3[];
  mapped: KeyValues3[];
}

export interface PricingManagementInitialization {
  detail?: PricingManagementDetail;
  pricings: PricingManagementWrapper[];
  pricingsExcluded: PricingManagementWrapper[];
  businessTaxesFull?: KeyValues5Sets[];
}

export interface PricingManagementDetail {
  isExistingDataAvailable?: boolean;
  productId?: string;
  productName?: string;
  batchId?: string;
  batchName?: string;
  selectedTaxCategoryId?: string;
  businessTaxCategories?: KeyValues5[];
}

export interface PricingManagementWrapper {
  content: KeyValues5;
  taxFinal: KeyValueSet[];
  requiredTax: KeyValues5[];
}

export interface ProductWrapper {
  content: KeyValues20;
  price: any;
  priceExclude: any;
  categories?: string[];
  languageContents: any;
  languageCategory: any;
  languageAbout: any;
  languageNotes: any;
  isAutoTransateAllowed: boolean;
  printTemplateIds: string[];
  customFields: KeyValues5[];
}

export interface ProductInitialization {
  measurementTypes: KeyValueSet[];
  product: ProductWrapper;
  categories: KeyValues3[];
  printerTemplates: KeyValueSet[];
}

export interface BillingDetailSimple {
  product: BilledProduct;
  billingId: string;
  status: Status;
  isRequestedForSearch: boolean;
  id: string;
}

export enum ChildReceiptType {
  None = 0,
  ProductRow_Tally1 = 1,
  TaxRow_Tally1 = 2,
  DetailedTaxHeader_Tally1 = 3,
  HsnTaxRow_Tally1 = 4,
  DetailedTaxRow_Tally1 = 5,
  DetailedTaxTotal_Tally1 = 6,
  ItemRow_Half_A4_1 = 7,
  PaymentModes = 8,
  ItemRow_A5_Tax_Item = 9,
  ItemRow_A5_Tax_Detail = 10,
}

export enum ReceiptCustomeLabelReplace {
  None = 0,
  GST_Label = 1,
  Telephone_Label = 2,
  AboutShop_Label = 3,
  Address_Label = 4,
  InvoiceNum_Label = 5,
  InvoiceNum_Value = 6,
  PaymentType_Label = 7,
  Date_Label = 8,
  Date_Value = 9,
  BilllingAddress_Label = 10,
  BilllingAddress_Value = 11,
  ShippingAddress_Label = 12,
  ShippingAddress_Value = 13,
  SN_Label = 14,
  ItemName_Label = 15,
  Quantity_Label = 16,
  Rate_Label = 17,
  Amount_Label = 18,
  EOE_Label = 19,
  Note_Label = 20,
  Total_Label = 21,
  Total_Value = 22,
  Notes_Label = 23,
  ForSignature_Label = 24,
  Header_Label = 25,
  RST_Label = 26,
  RST_Value = 27,
  Vehicle_Label = 28,
  Vehicle_Value = 29,
  Material_Label = 30,
  Material_Value = 31,
  Party_Label = 32,
  Party_Value = 33,
  GrossWt_Label = 34,
  GrossWt_Value = 35,
  TareWt_Label = 36,
  TareWt_Value = 37,
  NetWt_Label = 38,
  NetWt_Value = 39,
  Kgs_Label = 40,
  NetWtWord_Value = 41,
  Charges_Label = 42,
  Rs_Label = 43,
  Rs_Value = 44,
  OperatorSign_Label = 45,
  Contact_Label = 46,
  AmountWord_Label = 47,
  HSN_Label = 48,
  Taxable_Label = 49,
  TotalTaxAmount_Label = 50,
  TaxAmountWord_Label = 51,
  TaxInvoice_Label = 52,
  Page_Label = 53,
  CompanyName_Label = 54,
  BillTo_Label = 55,
  BuyerName_Value = 56,
  BuyerAddress_Value = 57,
  InvoiceNo_Label = 58,
  InvoiceNo_Value = 59,
  Dated_Label = 60,
  Dated_Value = 61,
  DeliveryNote_Label = 62,
  DeliveryNote_Value = 63,
  PaymentMode_Label = 64,
  PaymentMode_Value = 65,
  Reference_Label = 66,
  Reference_Value = 67,
  OtherReferences_Label = 68,
  OtherReferences_Value = 69,
  BuyerOrderNum_Label = 70,
  BuyerOrderNum_Value = 71,
  BuyerDated_Value = 72,
  Dispatch_Label = 73,
  Dispatch_Value = 74,
  DeliveryNoteBuyer_Value = 75,
  DispatchedThrough_Label = 76,
  DispatchedThrough_Value = 77,
  Destination_Label = 78,
  Destination_Value = 79,
  Terms_Label = 80,
  Terms_Value = 81,
  SiNo_Label = 82,
  ProductName_Label = 83,
  Qty_Label = 84,
  Per_Label = 85,
  Continue_Label = 86,
  ComputerGenerated_Label = 87,
  Declaration_Label = 88,
  DeclarationContent_Label = 89,
  CustomerSign_Label = 90,
  Bank_Label = 91,
  AcName_Label = 92,
  AcName_Value = 93,
  BankName_Label = 94,
  BankName_Value = 95,
  AcNum_Label = 96,
  AcNum_Value = 97,
  BranchIFS_Label = 98,
  BranchIFS_Value = 99,
  For_Label = 100,
  AuthorisedSign_Label = 101,
  DeliveryNoteDate_Label = 102,
  GrandTotal_Label = 103,
  GrandTotal_Value = 104,
  Adjustment_Label = 105,
  Discount_Label = 106,
  Discount_Value = 107,
  Adjustment_Value = 108,
  ShopNumber_Label = 109,
  Description_Label = 110,
  Staff_Label = 111,
  Size_Label = 112,
  TotalAmountIncludingTax_Value = 113,
  Description_Value = 114,
  Size_Value = 115,
  DeliveryChallan_Label = 116,
  DcRef_Label = 117,
  DcRef_Value = 118,
  OutgoingTrip_Label = 119,
  Loading_Label = 120,
  Loading_Value = 121,
  Unloading_Label = 122,
  Unloading_Value = 123,
  Transport_Label = 124,
  Transport_Value = 125,
  VehicleNo_Label = 126,
  VehicleNo_Value = 127,
  Item_Label = 128,
  Item_Value = 129,
  EmptyQty_Label = 130,
  EmptyQty_Value = 131,
  FullQty_Label = 132,
  FullQty_Value = 133,
  NetQty_Label = 134,
  NetQty_Value = 135,
  ThankYou_Label = 136,
  ShopName_Label = 137,
  HSN_Value = 138,
  Driver_Label = 139,
  Driver_Value = 140,
  GST_Value = 141,
  ShopName_Value = 142,
  CompanyName_Value = 143,
  Address_Value = 144,
  SiNo_Value = 145,
  Time_Label = 146,
  Time_Value = 147,
  Supplier_Label = 148,
  Supplier_Value = 149,
  Trip_Label = 150,
  Trip_Value = 151,
  Gross_Label = 152,
  Gross_Value = 153,
  Tare_Label = 154,
  Tare_Value = 155,
  Net_Label = 156,
  Net_Value = 157,
  CompanyNameAddress_Value = 158,
  BuyerName_Label = 159,
  Telephone_Value = 160,
  State_Label = 161,
  State_Value = 162,
  ShopNumber_Value = 163,
  CurrencyName_Label = 164,
  AmountPaid_Label = 165,
  AmountPaid_Value = 166,
  LineNumber_Label = 167,
  LineNumber_Value = 168,
  Staff_Value = 169,
  Qty_Value = 170,
  Rate_Value = 171,
  Amount_Value = 172,
  DiscountPercentage_Label = 173,
  DiscountPercentage_Value = 174,
  DiscountForItem_Label = 175,
  DiscountForItem_Value = 176,
  TaxableAmountForItem_Label = 177,
  TaxableAmountForItem_Value = 178,
  CgstAmountForItem_Label = 179,
  CgstAmountForItem_Value = 180,
  TotalAmountForItem_Label = 181,
  TotalAmountForItem_Value = 182,
  TotalItemsDiscountAmount_Value = 183,
  TotalItemsQty_Value = 184,
  CgstTotalTaxableAmount_Value = 185,
  SgstTotalTaxableAmount_Value = 186,
  SgstAmountForItem_Label = 187,
  SgstAmountForItem_Value = 188,
  SHIRT_Value = 189,
  TrailQty_Label = 190,
  TrailQty_Value = 191,
  TotalQty_Label = 192,
  TotalQty_Value = 193,
  HS_Label = 194,
  HS_Value = 195,
  FS_Label = 196,
  FS_Value = 197,
  TrailDate_Label = 198,
  TrailDate_Value = 199,
  DeliveryDate_Label = 200,
  DeliveryDate_Value = 201,
  OrderNO_Label = 202,
  OrderNO_Value = 203,
  Length_Label = 204,
  Length_Value = 205,
  Shoulder_Label = 206,
  Straight_Label = 207,
  Straight_Value = 208,
  Down_Label = 209,
  Down_Value = 210,
  HalfSleeves_Label = 211,
  Fold_Label = 212,
  Fold_Value = 213,
  FullSleeves_Label = 214,
  Front_Label = 215,
  Back_Label = 216,
  Chest_Label = 217,
  FrontChest_Value = 218,
  BackChest_Value = 219,
  Waist_Label = 220,
  FrontWaist_Value = 221,
  BackWaist_Value = 222,
  Hip_Label = 223,
  FrontHip_Value = 224,
  BackHip_Value = 225,
  Collar_Label = 226,
  Collar_Value = 227,
  SR_Label = 228,
  SR_Value = 229,
  SrRound_Label = 230,
  SrRound_Value = 231,
  FrontPocket_Label = 232,
  FrontPocket_Value = 233,
  InsidePocket_Label = 234,
  InsidePocket_Value = 235,
  ChinesCollar_Label = 236,
  ChinesCollar_Value = 237,
  RmStyle_Label = 238,
  RmStyle_Value = 239,
  PlainSlack_Label = 240,
  PlainSlack_Value = 241,
  LibertyCut_Label = 242,
  LibertyCut_Value = 243,
  CutwayCollar_Label = 244,
  CutwayCollar_Value = 245,
  PointCollar_Label = 246,
  PointCollar_Value = 247,
  SlimFit_Label = 248,
  SlimFit_Value = 249,
  MediumFit_Label = 250,
  MediumFit_Value = 251,
  BodyFit_Label = 252,
  BodyFit_Value = 253,
  PlainPatti_Label = 254,
  PlainPatti_Value = 255,
  InsidePatti_Label = 256,
  InsidePatti_Value = 257,
  FrontPatti_Label = 258,
  FrontPatti_Value = 259,
  PattiExtrawork_Label = 260,
  PattiExtrawork_Value = 261,
  CollarExtraWork_Label = 262,
  CollarExtraWork_Value = 263,
  FirstButton_Label = 264,
  FirstButton_Value = 265,
  CustomerInstructions_Label = 266,
  CustomerInstructions_Value = 267,
  SrFullRound_Label = 268,
  SrFullRound_Value = 269,
  //CollarExtraWork_Label = 270,
  //CollarExtraWork_Value = 271,
  CrossPocket_Label = 272,
  CrossPocket_Value = 273,
  Band_Label = 274,
  Band_Value = 275,
  PremiumGrip_Label = 276,
  PremiumGrip_Value = 277,
  Inseem_Label = 278,
  Inseem_Value = 279,
  StraightPocket_Label = 280,
  StraightPocket_Value = 281,
  NoPleat_Label = 282,
  NoPleat_Value = 283,
  FrinchFly_Label = 284,
  FrinchFly_Value = 285,
  InseemRound_Label = 286,
  InseemRound_Value = 287,
  BackPocket_Label = 288,
  BackPocket_Value = 289,
  _1Pleated_Label = 290,
  _1Pleated_Value = 291,
  DoubleStitch_Label = 292,
  DoubleStitch_Value = 293,
  Waist_Value = 294,
  BackPocketType_Value = 295,
  _2Pleated_Label = 296,
  _2Pleated_Value = 297,
  Iron_Label = 298,
  Iron_Value = 299,
  Hip_Value = 300,
  TicketPocket_Label = 301,
  TicketPocket_Value = 302,
  BottomFold_Label = 303,
  BottomFold_Value = 304,
  Loop_Label = 305,
  Loop_Value = 306,
  Thigh_Label = 307,
  Thigh_Value = 308,
  CoinPocket_Label = 309,
  CoinPocket_Value = 310,
  AankleFit_Label = 311,
  AankleFit_Value = 312,
  Knee_Label = 313,
  Knee_Value = 314,
  MobilePocket_Label = 315,
  MobilePocket_Value = 316,
  Hook_Label = 317,
  Hook_Value = 318,
  Bottom_Label = 319,
  Bottom_Value = 320,
  HookButton_Label = 321,
  HookButton_Value = 322,
  _1Button_Label = 323,
  _1Button_Value = 324,
  SideVent_Label = 325,
  SideVent_Value = 326,
  Shoulder_Value = 327,
  _2Button_Label = 328,
  _2Button_Value = 329,
  CenterVent_Label = 330,
  CenterVent_Value = 331,
  Sleeves_Label = 332,
  Sleeves_Value = 333,
  _3Button_Label = 334,
  _3Button_Value = 335,
  SingleBreast_Label = 336,
  SingleBreast_Value = 337,
  Chest_Value = 338,
  VestNeckU_Label = 339,
  VestNeckU_Value = 340,
  DoubleBreast_Label = 341,
  DoubleBreast_Value = 342,
  VestLength_Label = 343,
  VestLength_Value = 344,
  VestNeckV_Label = 345,
  VestNeckV_Value = 346,
  DBN_Label = 347,
  DBN_Value = 348,
  RegularFit_Label = 349,
  RegularFit_Value = 350,
  SuperSlimFit_Label = 351,
  SuperSlimFit_Value = 352,
  SBN_Label = 353,
  SBN_Value = 354,
  ExtraWork_Label = 355,
  ExtraWork_Value = 356,
  SationWork_Label = 357,
  SationWork_Value = 358,
  PhotoModel_Label = 359,
  PhotoModel_Value = 360,
  HalfSleeves_Value = 361,
  FullSleeves_Value = 362,
  ReceiptType_Label = 363,
  VisitorName_Label = 364,
  VisitorName_Value = 365,
  PatientName_Label = 366,
  PatientName_Value = 367,
  PatientId_Label = 368,
  PatientId_Value = 369,
  Relationship_Label = 370,
  Relationship_Value = 371,
  TimeRange_Label = 372,
  TimeRange_Value = 373,
  Contact_Value = 374,
  ImageUrl_Value = 375,
  BusinessCgstPercentage_Value = 376,
  BusinessSgstPercentage_Value = 377,
  Age_Label = 378,
  Age_Value = 379,
  Ward_Label = 380,
  Ward_Value = 381,
  OldOrderNumber_Label = 382,
  OldOrderNumber_Value = 383,
  OutsideOrderNumber_Label = 384,
  OutsideOrderNumber_Value = 385,
}

export interface BillingDetailsSimple {
  initialization?: BillingInitialization;
  products?: BilledProduct[];
  bill: KeyValues30;
  customer?: KeyValueSet;
  serviceBy?: KeyValueSet;
  status: BillingStatus;
  isActionsAllowed?: boolean;
  isExcluded: boolean;
  responseStatus?: StatusWithId;
  invalidProducts?: KeyValueSet[];
  lessMinumumQuantity?: KeyValueSet[];
  qrImage?: string;
  requ?: string;
  isNotConsiderTax: boolean;
  businessTaxes: KeyValueIdGroup[];
  taxTitles?: KeyValueId[];
  productPrintTemplates?: KeyValueId[];
  adjustmentFormulas?: BillingAdjustmentFormula[];
  customLabelsToPrint?: CustomPrintLabelForBill[];
  deliveryAddress?: KeyValues5[];
  paymentDetail?: KeyValueIdForPaymentModeWrapper;
  businessEnabledOptions?: BusinessEnabledOption[];
  businessTaxesFull?: KeyValues5Sets[];
  productTaxes?: PricingManagementWrapper[];
}

export interface ProductTaxes {
  productId: string;
  batchId?: string;
  measurementTypeStr: string;
  taxes?: KeyValueId[];
}

export interface BillingAdjustmentFormula {
  from: number;
  to: number;
  value: number;
}

export interface ReceiptTemplateWrapper {
  content: KeyValues5;
  languageHeaderTemplate: any;
  languageItemsTemplate: any;
  languageFooterTemplate: any;
  languageSupportingLinesTemplate: any;
  languageSerialNumbersTemplate: any;
  headerTemplate: KeyValueSet;
  contentTemplate: KeyValueSet;
  footerTemplate: KeyValueSet;
  supportingLinesTemplate: KeyValueSet;
  serialNumbersTemplate: KeyValueSet;
}

export interface ReceiptTemplate {
  Id: string;
  ParentId: string;
  Width: number;
  Styles: string;
  HTML?: string;
  ReceiptOptionsHtml?: KeyValueSetsInt[];
  IsActive: boolean;
  CreatedBy?: string;
  CreatedOn: Date;
  UpdatedBy?: string;
  UpdatedOn: Date;
}

export interface ReceiptHtml {
  Id: string | any;
  ReceiptType: number;
  ChildReceiptType?: number;
  ParentId?: string;
  HTML: string;
  Title: string;
  IsActive: boolean;
  CreatedBy: string;
  CreatedOn: Date;
  UpdatedBy: string;
  UpdatedOn: Date;
}

export interface KeyValueSetsInt {
  isSelected: boolean;
  key: number;
  value: string;
  values: KeyValueSetInt[];
}

export interface KeyValueSetInt {
  key: number;
  value: string;
}

export interface Selected {
  countryCode: string;
  user: string;
  applicationLanguage: string;
  token: string;
}

export interface BillingInitialization {
  businessTypes: KeyValueSet[];
  paymentMethods: KeyValueSet[];
  deliveryTypes: KeyValueSet[];
  measurementTypes: KeyValueSet[];
  businessEnabledOptions: BusinessEnabledOption[];
  billingMode: KeyValueSet[];
  isProductAvailable: boolean;
  isShowAllElligible: boolean;
}

export interface RelationshipInitialization {
  searchAs: KeyValues3[];
  selectedSearchAs: string;
  selectedRole: string;
  contents: Wrappers10;
  roles: KeyValueSet[];
}

export interface CountryDetail {
  code: KeyValues3;
  languages: KeyValues3[];
}

export interface Wrapper5Initialization {
  locations: GlobalLocations;
  content: Wrappers5;
  options: KeyValueSet[];
  reportBy: KeyValueSet[];
}

export interface Wrapper10Initialization {
  locations: GlobalLocations;
  content: Wrappers10;
  options: KeyValueSet[];
  configs_1: KeyValueSet[];
  configs_2: KeyValueSet[];
  reportBy: KeyValueSet[];
  paymentBy: KeyValueSet[];
}

export interface AllowedPageAction {
  pageKey: PageKey;
  isPageAllowed: boolean;
  allowedActions: PageAction[];
}

export interface BusinessRoleForUser {
  userId: string;
  businessId: string;
  roles: RelationShipRole[];
}

export interface Wrapper15Initialization {
  locations: GlobalLocations;
  content: Wrappers15;
  additional: KeyValues3;
  options: KeyValueSet[];
  reportBy: KeyValueSet[];
  paymentBy: KeyValueSet[];
  productLabels: KeyValueSet[];
}

export interface Wrapper20Initialization {
  locations: GlobalLocations;
  content: Wrappers20;
  additional: KeyValues3;
  options: KeyValueSet[];
  reportBy: KeyValueSet[];
  paymentBy: KeyValueSet[];
  productLabels: KeyValueSet[];
}

export interface RequestInitialization {
  statuses: KeyValueSetInt[];
  requestTypes: KeyValueSetInt[];
  selected: KeyValues3;
  content: Wrappers10;
}

export interface GlobalLocations {
  countries: KeyValueSet[];
  states: KeyValueSetWrapper;
  districts: KeyValueSetWrapper;
  constituencies: KeyValueSetWrapper;
  selected: KeyValues5;
}

export interface ReturnInitialization {
  returnReasons: KeyValueSet[];
  measurementTypes: KeyValueSet[];
  content: KeyValues10Group[];
}

export interface KeyValues10Group {
  key: KeyValues10;
  values: KeyValues10[];
}

export interface ToolPricingInitialization {
  chargeMethod: KeyValueSet[];
  toolPricingType: KeyValueSet[];
  notificationType: KeyValueSet[];
  items: KeyValues5[];
}

export interface KeyValueSetWrapper {
  responseStatus: Status;
  contents: KeyValueSet[];
  selectedKey: string;
  selectedParent: string;
}

export interface Graph {
  idName: string;
  graphType: GraphType;
  items: GraphData[];
  max: number;
}

export interface LoginAsParam {
  countryCode: string;
  userId: string;
  interactionType: InteractionType;
  businessId: string;
  businessIdAsCustomer: string;
  isShowBusiness: boolean;
}

export interface GraphData {
  x: string;
  y: number;
  date: any;
}

export interface ProductLogDetailsInitialization {
  statusSummary: KeyValueSet[];
  productColumnKey: KeyValueSet[];
  productLogStatus: KeyValueSet[];
  productLogReason: KeyValueSet[];
  businessTypes: KeyValueSet[];
  taxes: KeyValueSet[];
  details: KeyValues5[];
}

export interface BulkLogDetailsInitialization {
  statusSummary: KeyValueSet[];
  logStatus: KeyValueSet[];
  logReason: KeyValueSet[];
  columnKeys: KeyValueSet[];
  details: BulkLogDetail;
}

export interface BulkLogDetail {
  Id: string;
  ParentId: string;
  LogStatus: number;
  LogReason: number;
  LogData: KeyValueSetInt[];
}

export interface KeyValueInt {
  id?: string;
  key: number | string;
  value: number;
}

export interface LiveTokenWrapper {
  isEnabled: boolean;
  tokens: Wrappers15;
  billedProducts: BilledProductsGroup[];
}

export interface BilledProductsGroup {
  billingId: string;
  products: BilledProduct[];
}

export interface NumericConfig {
  isDecimalAllowed?: boolean; //Id is required for input field to get expected result
  maxValue?: number | null;
  maxDigits?: number | null; //Id is required for input field to get expected result
  navigateToNextIdIfMaxDigitReached?: string;
  isNegativeAllowed?: boolean;
  isStartWithZeroAllowed?: boolean;
  maxDecimalDigits?: number;
}

export enum PlanType {
  None = 0,
  TrailPeriod = 1,
  OneMonthFree = 2,
  BasicPlan = 3,
  Employee = 4,
  CustomReceipt = 5,
  LiveTokens = 6,
  SeatingManagement = 7,
  BatchDetails = 8,
}

export enum BasicPlanMonths {
  Custom = 1,
  _3Months = 3,
  _6Months = 6,
  _1Year = 12,
}

export enum ProductColumnKey {
  None = 0,
  ProductIdentificationNumber = 1,
  ProductName = 2,
  Barcode = 3,
  Measurement = 4,
  Price = 5,
  MinimumQuantity = 6,
  Tax = 7,
}

export enum ProductLogStatus {
  None = 0,
  Success = 1,
  SuccessWithWarning = 2,
  Failed = 3,
}

export enum BulkLogStatus {
  None = 0,
  Success = 1,
  SuccessWithWarning = 2,
  Failed = 3,
}

export enum BarCodeCategory {
  None = 0,
  General = 1,
  Product = 2,
  Me = 3,
  Business = 4,
  Products = 5,
  Sellers = 6,
  Billing = 7,
  SerialNumbers = 8,
  SerialNumber = 9,
  Payment = 10,
  ExploreProducts = 11,
}

export interface SerialNumberGenerate {
  id?: string;
  productId: string;
  isExpiryAllowed: boolean;
  expiryDate?: string;
  maximumCount: number;
  prefix: string;
  suffix: string;
  productSerialNumberType: ProductSerialNumberType;
}

export interface DecodedQrCode {
  countryCode: string;
  value: string;
  quantity: number;
  barCodeCategory: BarCodeCategory;
  isValid: boolean;
  isInternalBarCode: boolean;
  rawData: string;
  productId: string;
  businessId: string;
  interactionType: InteractionType;
}

export enum ActionType {
  None = 0,
  Create = 1,
  Delete = 2,
  ActiveOrInActive = 3,
  Cancel = 4,
  ApprovedByCustomer = 5,
  ApprovedByProvider = 6,
  AmountPaid = 7,
  UpdateBillingNotes = 8,
  UpdatePaymentMethod = 9,
  UpdateDeliveryType = 10,
  UndoBilling = 11,
  UpdateAppointment = 12,
  UpdateDeliveryAddress = 13,
  Update = 14,
  UpdateAdjustment = 15,
  UpdatePaidAmount = 16,
  UpdateDiscountAmount = 17,
}

export enum ActionTypeBillingDetail {
  None = 0,
  UpdateNotes = 1,
  UpdateStaff,
}

export enum BillingMode {
  None = 0,
  Receipt = 1,
  ShowAll = 2,
  QuickPick = 3,
}

export enum PageAction {
  None = 0,
  Add = 1,
  Update = 2,
  Active = 3,
  InActive = 4,
  Delete = 5,
  View = 6,
  ActiveAndInactive = 7,
}

export enum PageKey {
  None = 0,
  AllowedActions = 1,
  Billing = 2,
  Billings = 3,
  Countries = 4,
  Services = 5,
  FieldsConfig = 6,
  GeneralConfig = 7,
  GlobalConfig = 8,
  Languages = 9,
  LanguageContentsAll = 10,
  LanguageSectionConfig = 11,
  Locations = 12,
  Login = 13,
  Menus = 14,
  MyAccess = 15,
  MyPayments = 16,
  Notifications = 17,
  Products = 18,
  QrCode = 19,
  RelationShips = 20,
  Requests = 21,
  Search = 22,
  Seller = 23,
  Sellers = 24,
  SellersAdmin = 25,
  Settings = 26,
  Startup = 27,
  User = 28,
  Users = 29,
  UsersAccess = 30,
  Guide = 31,
  Gallery = 32,
  Appointments = 33,
  StartupConfig = 34,
  ProductCategories = 35,
  FromUs = 36,
  AboutUs = 37,
  PinnedServices = 38,
  SmsReportBusiness = 39,
  AdditionalDetails = 40,
  MyPaymentsServiceProvider = 41,
  AppointmentsServiceProvider = 42,
  NotificationsBusiness = 43,
  ContactUs = 44,
  PaymentTypes = 45,
  PaymentTypesServiceProvider = 46,
  AgreementAndDisclaimer = 47,
  LanguageSelection = 48,
  BillingsBusiness = 49,
  BillingBusiness = 50,
  RelationShipsBusiness = 51,
  RelationShipsServiceProvider = 52,
  Feedback = 53,
  SalesReport = 54,
  PricingCalculator = 55,
  ManageService = 56, //Service Provider
  CopyRights = 57,
  Logout = 58,
  Whitelists = 59,
  PageKeyAndRoleAccess = 60,
  PaymentsAdmin = 61,
  SmsReportServiceProvider = 62,
  FeedbackAdmin = 63,
  AppointmentsBusiness = 64,
  PrepaidServiceProvider = 65,
  PrepaidBusiness = 66,
  PrepaidUser = 67,
  PaymentGatewayServiceProvider = 68,
  PaymentGatewayBusiness = 69,
  PaymentGatewayUser = 70,
  CustomizeMenu = 71,
  PaidByCompanyBusiness = 72,
  PaidByCompanyServiceProvider = 73,
  RedirectUrl = 74,
  SeatReservationBusiness = 75,
  SeatReservationServiceProvider = 76,
  SeatReservationUser = 77,
  GetStarted = 78,
  Tips = 79,
  Reference = 80,
  MenuSettings = 81,
  Logs = 82,
  RequestsBusiness = 83,
  LiveTokens = 84,
  ManageBusinessService = 85,
  RefundAdmin = 86,
  RentReceiptLogs = 87,
  LoginWithLanguage = 88,
  TermsAndConditions = 89,
  PrivacyPolicy = 90,
  CancellationAndRefund = 91,
  ShippingAndDelivery = 92,
  GalleryBusiness = 93,
  Suppliers = 94,
  PurchaseEntries = 95,
  PurchaseEntryDetails = 96,
  Lookups = 97,
  LocalPrinter = 98,
  LocalPrinterSetup = 99,
  PlanPurchaseBusiness = 100,
  BatchEntries = 101,
  BatchEntryDetails = 102,
  BatchInventories = 103,
  QrPaymentLogs = 104,
  PaymentGatewayCustomer = 105,
  CustomPrintLabels = 106,
  PaymentGatewaysConfig = 107,
  PaymentGatewayConfig = 108,
  QrLabelGenerator = 109,
  QrTemplateConfig = 110,
  DeviceSettings = 111,
  DeviceInfos = 112,
  QrLabelUpload = 113,
  SaleSettlement = 114,
  LinkBusinesses = 115,
  AuthConfig = 116,
  ReceiptFiles = 117,
  B2BAccountAdmin = 118,
  InvoiceFromPnixSoft = 119,
  InvoiceToBusiness = 120,
  B2bMenuHeader = 121,
  AuditingMenuHeader = 122,
  Invoices = 123,
  TaskRequests = 124,
  TaskRequestsAdmin = 125,
  Expenses = 126,
  ReceiptCustomLabels = 127,
  NewReceiptCustomLabels = 128,
  B2bLicence = 129,
  BaseAmountConvertion = 130,
  BusinessSubscriptions = 131,
  CreateNoConfigureBill = 132,
  ViewNoConfigureBill = 133,
  DeviceNetworkSettings = 134,
  ReceiptTemplates = 135
}

export enum AccessRole {
  None = 0,
  SuperAdmin = 1,
  Admin = 2,
  Auditor = 3,
  Accountant = 4,
  InChange = 5,
  TechnicalAdmin = 6,
  GuideEditor = 7,
  LanguageEditor = 8,
  ComplaintsManager = 9,
}

export enum LanguageKeyType {
  None = 0,
  //TermsConditionLogin = 1,
  LanguageEquivalentTitle = 2,
  SectionWise = 3,
  Location = 4,
  Country = 5,
  Menu = 6,
  Configuration = 7,
  SellerName = 8,
  SellerAddress = 9,
  SellerDescription = 10,
  ProductName = 11,
  ProductCategory = 12,
  ProductAbout = 13,
  ProductNotes = 14,
  ReceiptHeader = 15,
  ReceiptContent = 16,
  ReceiptFooter = 17,
  GlobalConfig = 18,
  Fields = 19,
  MemberName = 20,
  ServiceProviderType = 21,
  UserGuideTitle = 22,
  UserGuideContent = 23,
  ProductQuickPick = 24,
  Startup = 25,
  ServiceProviderAddress = 26,
  ProductSearch = 27,
  GetStated = 28,
  Tips = 29,
  ReceiptSupportingLines = 30,
  ReceiptSerialNumbers = 31,
  SupplierName = 32,
  SupplierAddress = 33,
  SupplierNotes,
}

export enum StartUpType {
  None = 0,
  HeaderSlide = 1,
  FeatureCategory = 2,
  FeatureOption = 3,
}

export enum LastUsedSettingsType {
  None = 0,
  ApplicationLanguage = 1,
  //LocalLanguage = 2,
  VisitedURL = 3,
  PhoneNumber = 4,
  CountryId = 5,
  //BillingMode = 6,
  QrPrintSize = 7,
  LiveTokenStatuses = 8,
  SelectedLanguages = 9,
  TotalWidthProduct = 10,
  PriceSizeProduct = 11,
  TitleSizeProduct = 12,
  BarCodeSizeProduct = 13,
  TotalWidthBusiness = 14,
  TitleSizeBusiness = 15,
  BarCodeSizeBusiness = 16,
  DescriptionSizeBusiness = 17,
  LiveTokensShowOnlyMe = 18,
  ExploreProductLocation = 19,
  PaymentType = 20,
  PurchaseEntryPriceOption = 21,
  LiveTokenSelectedStatus = 22,
  SeatManagementTableMode = 23,
  IsListViewInReceiptCustomLabel = 24,
}

export enum WhiteListStatus {
  None = 0,
  Requested = 1,
  Activated = 2,
  Deactivated = 3,
  Rejected = 4,
}

export enum FileUploadFor {
  None = 0,
  Gallery = 1,
  MissedLanguage = 2,
  Locations = 3,
  AccessMapping = 4,
  UserGuide = 5,
  UserGuideManual = 6,
  Products = 7,
  ProductSerialNumber = 8,
  BulkUsers = 9,
  Lookups = 10,
  ReceiptIcon = 11,
  QrLabelGenerator = 12,
  UploadStocks = 13,
}

export enum OpenUi {
  None = 0,
  Calender = 1,
}

export enum ChargeMethod {
  None = 0,
  ToolPricingType = 1,
  NotificationType = 2,
}

export enum ToolPricingType {
  None = 0,
  BasicRentalForBusiness = 1,
  ChargeFrom3kTo1L = 2,
  Every1L = 3,
  BasicRentalForServiceProvider = 4,
  EveryUserAfterBasic = 5,
  WaiveOff = 6,
  AdditionalServiceLiveTokens = 7,
  AdditionalServiceSeatingManagment = 8,
  AdditionalServiceCustomizedBill = 9,
  Every30kSerialNumberAfterBasic = 10,
  Every5kProductsAfterBasic = 11,
  AdditionalBatchDetails = 12,
}

export enum ComplaintStatus {
  None = 0,
  New = 1,
  Assigned = 2,
  Closed = 3,
}

export enum PaymentType {
  None = 0,
  Cash = 1,
  Card = 2,
  Others = 3,
  Voucher = 4,
  CustomerAccount = 5,
  WalletWithCompany = 6,
  Upi = 7,
  QrCode = 8,
  ShowQrCode = 9,
  MultiPayment = 10,
  BulkUpdate = 11,
  BankTransfer = 12,
}

export enum SessionConfigType {
  None = 0,
  Add = 1,
  AttachBill = 2,
  View = 3,
  Delete = 4,
  SeatInfo = 5,
}

export enum ServiceType {
  None = '',
  Express = 'express',
  DotNet = '.net',
}

export enum AdditionalServiceType {
  None = 0,
  LiveTokensAndProducts = 1,
  SeatingManagment = 2,
  CustomizedBill = 3,
  BatchDetails = 4,
}

export enum AdditionalServiceStatus {
  None = 0,
  FreeVersion = 1,
  Activated = 2,
  DeActivated = 3,
  YetToDeActivate = 4,
  ActivatedWithGracePeriod = 5,
}

export enum CountryLocationLevel {
  None = 0,
  State = 1,
  District = 2,
  Constituency = 3,
  Province = 4,
  Territories = 5,
  Counsil = 6,
}

export enum PagingMembers {
  None = 0,
  Name = 1,
  PhoneNumber = 2,
  Email = 3,
  Address = 4,
  PostalCode = 5,
  IdOrQR = 6,
}

export enum PagingSellers {
  None = 0,
  Name = 1,
  PhoneNumber = 2,
  Email = 3,
  Address = 4,
  PostalCode = 5,
  IdOrQR = 6,
}

export interface SelectedLocation {
  CountryCode: string;
  CountryId?: string | undefined;
  StateId?: string | undefined;
  DistrictId?: string | undefined;
  ConstituencyId?: string | undefined;
  PostalCode: string;
}

export interface StatusKeyValues5 {
  statusWithId: StatusWithId;
  content: KeyValues5;
}

export enum UsageLimitType {
  None = 0,
  BulkDownloadProduct = 1,
  BulkUploadProduct = 2,
  MaximumItemsPerReceipt = 3,
}

export enum ProductSerialNumberType {
  None = 0,
  NumberOnly = 1,
  AlphaNumeric = 2,
}

export enum UserGuideType {
  None = 0,
  PageKey = 1,
  FAQ = 2,
}

export enum PaymentGatewayServiceType {
  RandomOrNone = 0,
  RazorPay = 1,
  IppoPay = 2,
  Stripe = 3,
  Plural = 4,
  CCAvenue = 5,
  GooglePayment = 6,
}

export interface CommunicationTemplateReq {
  countryCode: string;
  communicationTemplateType: number;
  notificationType: NotificationType;
  communicationGatewayType: CommunicationGateway;
}

export enum ServiceApiType {
  None = 0,
  LazyDigiSol = 2,
  //Offline = 1,
  LazyDigiSolBulk = 3,
  CurrentApplication = 4,
  CurrentApplicationBulk = 5,
}

export enum CommunicationGateway {
  None = 0,
  Plivo = 1,
  Message91 = 2,
}

export enum PaidType {
  None = 0,
  Notification = 1,
  MonthlyBill = 2,
  Prepaid = 3,
  InvoiceGenerated = 4,
}

export enum PaymentGatewayOrderStatus {
  None = 0,
  Initiated = 1,
  Success = 2,
  Failed = 3,
  Cancelled = 4,
}

export enum CallbackType {
  Order = 1,
  Qr = 2,
}

export enum GalleryType {
  None = 0,
  BusinessBanner = 1,
  ProductImage = 2,
  ReceiptFile = 3,
  ReceiptFileSample = 4,
}

export enum ReceiptOption {
  CompanyAddress = 1,
  ServiceBy = 2,
  CompanyLogo = 3,
  CompanyName = 4,
  Disclaimer = 5,
  EMail = 6,
  CompanyContactNumber = 7,
  QR_Code = 8,
  ComputerGeneratedInvoice = 9,
  WebSite = 10,
  AdjustmentRoundOff = 11,
  ReceiptNumber = 12,
  DateTime = 13,
  DiscountOffer = 14,
  WelcomeMessage = 15,
  GrandTotal = 16,
  TotalQuantity = 17,
  ItemName = 18,
  PaidAmount = 19,
  ItemQuantity = 20,
  UnitPrice = 21,
  ItemTotalCost = 22,
  ModeOfPayment = 23,
  TotalLineNumber = 24,
  CompanyCGST = 25,
  CompanyIGST = 26,
  LicenceNumber = 27,
  ProductTaxAll = 28,
  ProductTaxAsConfigued = 29,
  ProductSerialNumber = 30,
  CompanySGST = 31,
  PoweredBy = 32,
  ItemRow_2X3__1 = 33,
  ItemHeader_2X3__2 = 34,
  LineNumber = 35,
  ItemCode = 36,
  RemainingAmount = 37,
  BillStatus = 38,
  CustomerName = 39,
  DeliveryAddress = 40,
  AppointmentToken = 41,
  DeliveryMethod = 42,
  AllotmentNumber = 43,
  SerialNumberHeader = 44,
  ProductTaxHeader = 45,
  GSTIN = 46,
  ProductTaxes = 47,
  BusinessTaxes = 48,
  ProductTaxesRow = 49,
  BusinessTaxesRow = 50,
  FSSAI = 51,
  HsnCode = 52,
  SacCode = 53,
  ItemRow_1X4__1 = 54,
  ItemHeader_1X4__2 = 55,
  BatchIdentity = 56,
  BatchIdentityIfMoreThanOneForSameProduct = 57,
  CustomLabelTop = 58,
  CustomLabelBottom = 59,
  MeasurementType = 60,
  Total = 61,
  TaxAmount = 62,
  TotalAmountIncludingTax = 63,
  CustomField = 64,
  ItemTotalCostWithTax = 65,
  ItemCreatedBy = 66,
  CustomerContact = 67,
  PaidOn = 68,
  BillNumber = 69,
  BillAndTokenNumber = 70,
  Date = 71,
  Time = 72,
  TotalItemsDiscountAmount = 73,
  TotalItemsCgstAmount = 74,
  TotalItemsSgstAmount = 75,
  ItemTaxableAmount = 76,
  ItemDiscountAmount = 77,
  ItemCgstAmount = 78,
  ItemSgstAmount = 79,
  ItemDiscountPercentage = 80,
  TotalItemsTaxableAmount = 81,
  BrnAddress = 82,
  BillOrTokenNumber = 83,
  BusinessCgstPercentage = 84,
  BusinessSgstPercentage = 85,
  AcceptanceSerialNumber = 86,
  TotalItemsIgstAmount = 87,
  ItemIgstAmount = 88,
  ItemTaxableUnitPrice = 89,
  ItemTaxableAmountWithoutDiscount = 90,
  ItemTaxableUnitPriceWithoutDiscount = 91,
  TotalWithoutDiscount = 92,
  TotalItemsNonTaxableAmount = 93,
  ServiceChargeAmount = 94,
  EstimateHeader = 95
}

export enum ReplaceLabelLoop {
  SN = 1,
  ItemName = 2,
  Quantity = 3,
  Rate = 4,
  Amount = 5,
}

export enum ReceiptOptionGroup {
  ItemRow = 1,
  ItemHeader = 2,
}

export enum UpadatePurchaseEntryDetailFor {
  None = 0,
  Quantity = 1,
  Price = 2,
  PurchaseEntryStatus = 3,
}

export enum UpadateBatchEntryDetailFor {
  None = 0,
  Quantity = 1,
}

export enum ReceiptOptionContains {
  Value = 1,
  Header = 2,
  HeaderFromOption = 3,
  Option = 4,
}

export enum BusinessEnabledOption {
  None = 0,
  HasInventory = 1,
  IsPrivate = 2,
  IsOpenNow = 3,
  HasImage = 4,
  CanPublicAccessReceipt = 5,
  ShowPaidButtonInReceiptPage = 6,
  ShowAcceptButtonInReceiptPage = 7,
  ShowReadyButtonInReceiptPage = 8,
  ShowOutForDeliveryButtonInReceiptPage = 9,
  ShowDeliveredButtonInReceiptPage = 10,
  ShowAdjustmentBoxInReceiptPage = 11,
  ShowDiscountBoxInReceiptPage = 12,
  ShowPaidAmountBoxInReceiptPage = 13,
  NeedOtpVerificationWhileAddingCustomer = 14,
  ConsiderBaseAmountAsTaxInCludedAmount = 15,
  GlobalProdcutBarCode = 16,
  PrintOncePaid = 17,
  NaviateToNewBillIfPaid = 18,
  HidePrintOptionInBillingPage = 19,
  ShowSmsButtonInBillingPage = 20,
  SendRemainingAmountToUserCredit = 21,
  IsEnableBatchDetails = 22,
  PrintCustomLabelsInReceipt = 23,
  IsExcludedPricingEnabled = 24,
  CanOverWritePricing = 25,
  DisablePrintOnDraft = 26,
  DetachTableBillOncePaid = 27,
  MaintainStatusForInventory = 28,
  DisableDirectStockEntry = 29,
  IsShowImageInQuickPick = 30,
  DisablePrintInViewMode = 31,
  DisableReturnItemInBilling = 32,
  //IsShowTaxIncludedPricingInBillingPage = 33,
  IsShowOnlyAcceptAndPrintButtonInCustomReceiptPage = 34,
  CanOverWriteDiscount = 35,
  //AutoRoundupItemInReceipt = 36,
  LockPreviewPrintReceiptOfDefault = 37,
  LockCustomLabelsIfAccepted = 38,
  ShowAcceptanceSerailNumberInViewBill = 39,
  AllowToModifyOnAcceptedStatus = 40,
}

export enum LookupType {
  None = 0,
  HSN = 1,
  SAC = 2,
}

export enum PrinterTab {
  None = 0,
  AvailablePrinters = 1,
  Templates = 2,
  TemplateMapping = 3,
  Devices = 4,
  DeviceMapping = 5,
}

export enum SupportingType {
  None = 0,
  Billing = 1,
  TestMode = 2,
}

export interface CustomPrintLabelForBills {
  items: CustomPrintLabelForBill[];
  replaceOptions?: KeyValuesId[];
  content?: KeyValues10;
  paymentMethods: KeyValueSet[];
  redirectBillingId?: string;
}

export interface KeyValuesId {
  id?: string;
  key: string;
  values: string[];
  text?: string;
}

export interface CustomPrintLabelForBill {
  isSelected: boolean;
  isEditable: boolean;
  customLabelInputType: string;
  optionsValue?: string;
  groupBy?: string;
  isMultiLine: boolean;
  key?: string;
  title: string;
  label?: string;
  value?: string;
  orderNumber?: number;
  isTopPrint?: boolean;
  isTitleBold?: boolean;
  isValueBold?: boolean;
  isCenterAlign?: boolean;
  isValueRightAlign?: boolean;
  isTopLineRequired?: boolean;
  isColonRequired?: boolean;
  isPrintEmptyValue?: boolean;
  marginTop?: number;
  receiptOption?: number;
  isAutoIncreaseValue?: boolean;
  isValueCommonFoAllLanguage?: boolean;
  receiptCustomeLabelReplace?: number;
  isPinned: boolean;
  customStyle?: CustomStyle;
  displayName?: string;
  printerTemplateId: string;
  selectedOptions?: KeyValueSet[];
  groupedItems?: CustomPrintLabelForBill[];
}

export interface CustomStyle {
  isBold?: boolean;
  fontSize?: number;
  isRight?: boolean;
  isLeft?: boolean;
  isCenter?: boolean;
  isItalic?: boolean;
  isUnderline?: boolean;
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  lineHeight?: number;
  letterSpacing?: number;
  width?: number;
  height?: number;
}

export interface FontStyleDetailWrapper {
  key?: string;
  businessId: string;
  lineHeight?: number;
  itemsLineHeight?: number;
  fontStyleDetails: FontStyleDetail[];
  fontNameOptions?: FontStyleDetailOption[];
}

export interface FontStyleDetail {
  languageCode: string;
  fontNameCode?: string;
  fontSize?: number;
  lineHeight?: number;
}

export interface FontStyleDetailOption {
  languageCode: string;
  value: string;
  s_value: string;
  fontOptions: KeyValueSet[];
  isNoFont?: boolean;
  selectedFontNameCode?: string;
  selectedLineHeight?: number;
  selectedFontSize?: number;
}

export interface LastUsedKey {
  userOrBusinessId: string;
  inteactionType: number;
  keyType: number;
  value: string;
}

export enum CustomLabelInputType {
  None = 0,
  SingleInputBox = 1,
  MultiLineInputBox = 2,
  SingleSelect = 3,
  MultiSelect = 4,
  ImageUpload = 5,
  SingleSelectDropdown = 6,
  HourOrDayInput = 7,
  RadioButton = 8,
}

export enum BillingValidation {
  None = 0,
  BusinessHasPurchaseEntry,
  BusinessHasValidBatchDetails,
  BusinessHasBizTaxes,
  NotConsiderTax,
  BusinessHaInventory,
}

export interface AddBillWrapper {
  bill: KeyValues15;
  product: KeyValues3;
  bizTaxes?: KeyValueIdGroup[];
  billingValidations: BillingValidation[];
  tableId?: string;
  providerId?: string;
}

export interface KeyValueIdGroup {
  key: string;
  values: KeyValueId[];
}

export interface RazorPayCustomerResponse extends RazorPayCustomerRequest {
  Id: string;
}

export interface RazorPayCustomerRequest {
  BusinessId: string;
  Name: string;
  Email: string;
  ContactNumber: string;
  PrefixContactNumber: string;
  GSTIN: string;
  QrType: QrType;
  FundAccount?: RazorPayCustomerFundAccountRequest;
}

export interface RazorPayCustomerFundAccountRequest {
  Id?: string;
  CustomerId: string;
  BankAccountName: string;
  BankAccountNumber: string;
  BankIfsc: string;
}

export interface QrGenerateRequest {
  businessId: string;
  gatewayType: PaymentGatewayServiceType;
  supportingId: string;
  supportingType: number;
  configIdOrFundAccountId?: string;
  amount: number;
  customerId?: string;
  name?: string;
  qrUsage?: string;
  qrType?: QrType;
  appUrl?: string;
}

export enum QrType {
  BharatQr = 'bharat_qr',
  UpiQr = 'upi_qr',
}

export enum TokenFormatType {
  YearMonthDay = 1,
  DayMonthYear = 2,
}

export enum CloneBusinessOption {
  None = 0,
  Products = 1,
  QrGeneratorConfig = 2,
  CustomLabelsConfig = 3,
  LocalPrintersConfig = 4,
  DecviceSettingsConfig = 5
}

export enum DeviceOS {
  Windows = 1,
  MacOS = 2,
  Linux = 3,
  Android = 4,
  IOS = 5,
}

export enum NetworkType {
  None = 0,
  Printer = 1,
  WeightMachine = 2,
}

export interface LocalNetworkSetting {
  Id: string,
  BusinessId: string,
  Title: string,
  STitle: string,
  DeviceCount: number,
  NetworkType: number | string,
  NetworkUrl: string,
  TemporaryFolderPath?: string,
  IsActive: boolean,
  CreatedBy: string,
  CreatedOn: Date,
  UpdatedBy: string,
  UpdatedOn: Date
}

export interface LocalWeightMachineName {
  Id: string;
  LocalNetworkSettingId: string;
  BusinessId: string;
  WeightMachineName: string;
  IsActive: boolean;
}

export interface LocalNetworkSettingWrapper {
  src?: string;
  item: LocalNetworkSetting;
  printers: LocalPrinterName[];
  weightMachinePortPath?: string;
}

export interface LocalPrinterName {
  Id: string,
  LocalNetworkSettingId: string,
  BusinessId: string,
  PrinterName: string,
  IsActive: boolean
}

export interface WeightMachineConnetion {
  businessId: string;
  directUrl?: string;
  networkUrl?: string;
  portPath?: string;
}